(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.DisneyTXT = function() {
	this.initialize(img.DisneyTXT);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,310,125);


(lib.LogoENCANTO_solo = function() {
	this.initialize(img.LogoENCANTO_solo);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,648,151);


(lib.Mapadebits17 = function() {
	this.initialize(img.Mapadebits17);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,81,95);


(lib.Mapadebits18 = function() {
	this.initialize(img.Mapadebits18);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,69);


(lib.Mapadebits19 = function() {
	this.initialize(img.Mapadebits19);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,59,112);


(lib.parcheblanco = function() {
	this.initialize(img.parcheblanco);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,795,381);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Símbolo12 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0E3182").s().p("ACHArIAAgIIAEABIAFgBIACgDIADgGIAAgCIgSgvIAJAAIAKAbIADALIAEgLIAKgbIAIAAIgSAwIgFALQgCADgDACQgCADgEAAIgGgBgABYATQgGgHAAgLQAAgMAGgGQAGgHAKAAQAKAAAGAHQAGAGAAALIAAACIgkAAQAAAIAFAEQAEAEAGABQAEgBADgCQADgDACgEIAJABQgCAHgGAEQgFAEgIAAQgLAAgGgGgABfgOQgEAEgBAGIAbAAQAAgFgDgEQgEgEgGAAQgFAAgEADgAgJAVQgFgEgBgHIAIgBQAAAEADADQAEACAEABQAGgBACgCQADgCAAgDQAAgDgCgBIgJgEIgLgDQgDgBgCgDQgCgCAAgEQAAgDABgDQACgDACgCIAGgCIAGgBQAFAAAFABQAEACACADQACACABAGIgIABQgBgEgCgCQgDgCgFAAQgEAAgDACQgCACAAACIABADIADACIAGACIAMAEQAEAAACADQABADAAAEQAAAEgCAEQgCADgFACQgEACgGAAQgIAAgFgEgAidAUQgIgEgFgIQgEgIAAgIQAAgJAEgIQAFgJAIgEQAIgEAJgBQAJABAIAEQAIAEAFAJQAEAIAAAJQAAAIgEAIQgFAIgIAEQgIAFgJAAQgJAAgIgFgAiaghQgHAEgEAGQgDAHAAAIQAAAHADAGQAEAGAHAFQAHADAHAAQAHAAAHgDQAHgFAEgGQADgGAAgHQAAgIgDgHQgEgGgHgEQgHgEgHABQgHgBgHAEgABAAYIAAgcIgBgIQgBgCgDgBQgCgCgDAAQgFAAgEADQgEADAAAKIAAAZIgIAAIAAgvIAHAAIAAAHQAFgIAKAAQAFAAADABQAEACACADQACACAAADIABAIIAAAdgAghAYIAAgvIAIAAIAAAvgAhjAYIAAhBIAXAAIAMAAQAFACAEAEQAFAEADAHQADAGAAAKQAAAHgCAFQgCAFgDAEQgCAFgEABIgIAEIgKABgAhaAQIAOAAIAKgBIAGgEQADgDACgFQACgEAAgHQAAgLgEgGQgDgFgFgCQgEgBgHgBIgOAAgAiZAFQgFgFAAgIQAAgGACgEQADgFAEgCQAEgCAFAAQAGAAAEACQAEADACAFIgGACQgBgEgDgCQgCgCgEAAQgFAAgDAFQgEADAAAHQAAAHAEADQADADAFAAQAEAAADgDQADgBABgEIAFACQgBAFgEADQgFADgGABQgIgBgFgFgAghggIAAgJIAIAAIAAAJg");
	this.shape.setTransform(17.525,4.35);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Símbolo12, new cjs.Rectangle(0,0,35.1,8.7), null);


(lib.Símbolo10copia = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E55A37").s().p("AhLBMQgfgfgBgtQABgsAfgfQAfgfAsgBQAtABAfAfQAfAfABAsQgBAtgfAfQgfAfgtABQgsgBgfgfg");
	this.shape.setTransform(10.75,10.75);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Símbolo10copia, new cjs.Rectangle(0,0,21.5,21.5), null);


(lib.Símbolo10 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFE200").s().p("AhLBMQgfgfgBgtQABgsAfgfQAfgfAsgBQAtABAfAfQAfAfABAsQgBAtgfAfQgfAfgtABQgsgBgfgfg");
	this.shape.setTransform(10.75,10.75);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Símbolo10, new cjs.Rectangle(0,0,21.5,21.5), null);


(lib.Símbolo7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AgxAZQgUgKAAgPQAAgOAUgKQAVgJAcgBQAdABAVAJQAUAKAAAOQAAAPgUAKQgVAKgdAAQgcAAgVgKg");
	var mask_graphics_1 = new cjs.Graphics().p("AgqBHQgVgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgaASgSQATgTAaAAQAZAAASATQATASAAAaQAAASgJAPQAJACAHADQAVAKAAAPQAAAPgVAKQgUAKgdAAQgcAAgVgKg");
	var mask_graphics_2 = new cjs.Graphics().p("AhDBbQgVgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgZASgTQATgSAaAAIAGAAQAFgLAJgJQAUgVAdAAQAeAAAUAVQAVAVAAAdQAAAdgVAUQgUAVgeAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgUAKgcAAQgdAAgVgKg");
	var mask_graphics_3 = new cjs.Graphics().p("AiIBoQgVgKAAgOQAAgKAIgHIgDgDQgSgSAAgaQAAgZASgSQATgTAaAAIAGAAQAFgLAJgJQAVgVAdAAIACAAIABAAQAigaAyAAQAyAAAkAaQAjAaAAAlQAAAlgjAZQgkAbgyAAQgkAAgcgOQgLADgMABIgBAAIABAAQAVAKAAAPQAAAOgVAKQgUAKgdAAQgdAAgVgKg");
	var mask_graphics_4 = new cjs.Graphics().p("AhIBVQgagMgQgPIgEAAQglAAgdgOQgKAEgMAAIgBAAIABAAQAUAKAAAPQAAAOgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgOQAAgJAHgIIgDgCQgSgTAAgaQAAgZASgSQATgTAaAAIAGABQAFgLAJgKQAVgUAeAAIABAAIABgBQAjgaAzAAQAuAAAiAXQA7gVBOAAQBkAABHAjQBHAjAAAxQAAAxhHAjQhHAkhkAAQhkAAhHgkg");
	var mask_graphics_5 = new cjs.Graphics().p("ABHCDQgxgjgRgsQgiAFgmAAQhlAAhHgkQgagMgQgOIgEAAQglAAgdgNQgKADgMAAIgBAAIABAAQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgGIgDgDQgSgSAAgbQAAgaASgSQATgTAaAAIAGABQAFgLAJgJQAVgVAeAAIABAAIABgBQAjgZAzAAQAuAAAiAWQA8gVBOAAQBjAABHAjIACABQBAggBTgBQBqAABLA1QBLA2AABKQAABMhLA1QhLA2hqAAQhqAAhLg2g");
	var mask_graphics_6 = new cjs.Graphics().p("AHCFJQgggcAAgoIAAgLQgRADgTAAQhNAAg3g3Qg3g3AAhOQAAgiAKgdQgoAKgvAAQhqAAhKg0QgxgjgRgsQgiAFgnAAQhlAAhHgkQgZgMgRgPIgEAAQglAAgcgOQgLAEgMAAIgBAAIABAAQAVAKAAAPQAAAOgVAKQgVAKgdAAQgdAAgVgKQgUgKAAgOQAAgJAIgIIgDgCQgTgTAAgaQAAgaATgSQASgTAaAAIAGABQAFgLAJgKQAVgUAeAAIABAAIABgBQAkgaAyAAQAuAAAiAXQA8gVBOAAQBkAABHAjIACABQA/ghBTAAQBqAABLA1QBLA2AABLQAAAagIAWIAQAAQBOAAA3A3QA3A3AABMQAAAngOAhQARADANAIQAUANAAASQAAAGgCAFIAFAEQAhAcAAAnQAAAoghAcQghAcguAAQgvAAghgcg");
	var mask_graphics_7 = new cjs.Graphics().p("AESHuQgqgcgBgpQABgpAqgdQArgdA8AAIAEAAQgKgeAAgkQAAhIAogzIAJgLQgFgPAAgQIAAgMQgRADgTAAQhNAAg4g3Qg3g2ABhNQgBgiALgdQgpAKguAAQhqAAhKg2QgxgjgRgsQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQBNAAA4A3QA3A3AABOQgBAmgNAhQARADAMAIQAVANAAARQAAAGgCAGIAFADQAgAcABAoQAAAhgXAZQAdAuAAA9QAABIgoAzQgjAsgwAGQgEAkgmAZQgrAdg8AAQg8AAgrgdg");
	var mask_graphics_8 = new cjs.Graphics().p("AAjIGQgrgUgJgbQgVgCgQgJQgJgFgFgGIgOABQggAAgXgKQgXgJABgOQgBgIAIgGQgJgFAAgHQAAgLAZgIQAZgIAjAAQAiAAAZAIQAKgNAUgKQApgVA6AAQA6AAApAVQATAJAKAMQALgUAXgQQArgcA8AAIAEAAQgKgfAAgjQAAhJAogyIAJgLQgFgPAAgRIAAgLQgRADgTAAQhNAAg4g3Qg3g2ABhOQgBghALgeQgpALguAAQhqAAhKg2QgxgjgRgsQgjAFgmAAQhlAAhHgkQgagMgQgPIgEAAQglAAgdgNQgKADgMAAIgBAAIABAAQAUAKAAAPQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgbQAAgaASgSQATgTAaAAIAGABQAFgLAJgJQAVgVAeAAIABAAIABgBQAjgZAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTgBQBqAABLA1QBLA2AABLQAAAagJAXIARgBQBNAAA4A3QA3A3AABNQgBAngNAhQARADAMAIQAVANAAASQAAAGgCAEIAFAEQAgAcABAnQAAAhgXAZQAdAuAAA+QAABHgoAzQgjAtgwAGQgEAjgmAaQgrAdg8AAQgYAAgUgFQgNALgUAJQg3AZhOAAQhNAAg3gZg");
	var mask_graphics_9 = new cjs.Graphics().p("AAjIGQgrgUgJgbQgVgCgQgJQgJgFgFgGIgOABQggAAgXgKQgUgJgCgLIgPABQghAAgXgPQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhdAphBQArhCA6AAQAfAAAaARQAWgjAgAAQAgAAAYAlQAWAmAAA1QAAA1gWAmQgLASgNAJQgBBPggA8QAIADAHAFQARALAFAOIAHAAQAiAAAXAOQATAMADAQIATAAQAiAAAZAIQAKgNAUgKQApgVA6AAQA6AAApAVQATAJAKAMQALgUAXgQQArgcA8AAIAEAAQgKgfAAgjQAAhJAogyIAJgLQgFgPAAgRIAAgLQgRADgTAAQhNAAg4g3Qg3g2ABhOQgBghALgeQgpALguAAQhqAAhKg2QgxgjgRgsQgjAFgmAAQhlAAhHgkQgagMgQgPIgEAAQglAAgdgNQgKADgMAAIgBAAIABAAQAUAKAAAPQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgbQAAgaASgSQATgTAaAAIAGABQAFgLAJgJQAVgVAeAAIABAAIABgBQAjgZAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTgBQBqAABLA1QBLA2AABLQAAAagJAXIARgBQBNAAA4A3QA3A3AABNQgBAngNAhQARADAMAIQAVANAAASQAAAGgCAEIAFAEQAgAcABAnQAAAhgXAZQAdAuAAA+QAABHgoAzQgjAtgwAGQgEAjgmAaQgrAdg8AAQgYAAgUgFQgNALgUAJQg3AZhOAAQhNAAg3gZg");
	var mask_graphics_10 = new cjs.Graphics().p("AAjIGQgrgUgJgbQgVgCgQgJQgJgFgFgGIgOABQggAAgXgKQgUgJgCgLIgPABQghAAgXgPQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhdAphBQArhCA6AAQAfAAAaARQAWgjAgAAQAgAAAYAlQANAWAFAbQAhgLApAAQA3AAAmAUQAoAUAAAcQAAAcgoAVQgmAUg3AAQgvAAgjgOQgEALgGAKQgLASgNAJQgBBPggA8QAIADAHAFQARALAFAOIAHAAQAiAAAXAOQATAMADAQIATAAQAiAAAZAIQAKgNAUgKQApgVA6AAQA6AAApAVQATAJAKAMQALgUAXgQQArgcA8AAIAEAAQgKgfAAgjQAAhJAogyIAJgLQgFgPAAgRIAAgLQgRADgTAAQhNAAg4g3Qg3g2ABhOQgBghALgeQgpALguAAQhqAAhKg2QgxgjgRgsQgjAFgmAAQhlAAhHgkQgagMgQgPIgEAAQglAAgdgNQgKADgMAAIgBAAIABAAQAUAKAAAPQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgbQAAgaASgSQATgTAaAAIAGABQAFgLAJgJQAVgVAeAAIABAAIABgBQAjgZAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTgBQBqAABLA1QBLA2AABLQAAAagJAXIARgBQBNAAA4A3QA3A3AABNQgBAngNAhQARADAMAIQAVANAAASQAAAGgCAEIAFAEQAgAcABAnQAAAhgXAZQAdAuAAA+QAABHgoAzQgjAtgwAGQgEAjgmAaQgrAdg8AAQgYAAgUgFQgNALgUAJQg3AZhOAAQhNAAg3gZg");
	var mask_graphics_11 = new cjs.Graphics().p("AAjIGQgrgUgJgbQgVgCgQgJQgJgFgFgGIgOABQggAAgXgKQgUgJgCgLIgPABQghAAgXgPQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhdAphBQArhCA6AAQAfAAAaARQAWgjAgAAQAgAAAYAlQANAWAFAbQAhgLApAAQA3AAAmAUIAJAEQAlgSAxAAQA3ABAmAVQAoAXAAAgQAAAggoAXQgmAXg3gBQg2ABgngXQgLgHgHgHQgiANgrAAQgvAAgjgOQgEALgGAKQgLASgNAJQgBBPggA8QAIADAHAFQARALAFAOIAHAAQAiAAAXAOQATAMADAQIATAAQAiAAAZAIQAKgNAUgKQApgVA6AAQA6AAApAVQATAJAKAMQALgUAXgQQArgcA8AAIAEAAQgKgfAAgjQAAhJAogyIAJgLQgFgPAAgRIAAgLQgRADgTAAQhNAAg4g3Qg3g2ABhOQgBghALgeQgpALguAAQhqAAhKg2QgxgjgRgsQgjAFgmAAQhlAAhHgkQgagMgQgPIgEAAQglAAgdgNQgKADgMAAIgBAAIABAAQAUAKAAAPQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgbQAAgaASgSQATgTAaAAIAGABQAFgLAJgJQAVgVAeAAIABAAIABgBQAjgZAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTgBQBqAABLA1QBLA2AABLQAAAagJAXIARgBQBNAAA4A3QA3A3AABNQgBAngNAhQARADAMAIQAVANAAASQAAAGgCAEIAFAEQAgAcABAnQAAAhgXAZQAdAuAAA+QAABHgoAzQgjAtgwAGQgEAjgmAaQgrAdg8AAQgYAAgUgFQgNALgUAJQg3AZhOAAQhNAAg3gZg");
	var mask_graphics_12 = new cjs.Graphics().p("AAjIGQgrgUgJgbQgVgCgQgJQgJgFgFgGIgOABQggAAgXgKQgUgJgCgLIgPABQghAAgXgPQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhdAphBQArhCA6AAQAfAAAaARQAWgjAgAAQAgAAAYAlQANAWAFAbQAhgLApAAQA3AAAmAUIAJAEQAlgSAxAAQA3ABAmAVIAFACQAJgFAKgEQgsgzAAhGQgBghALgeQgpALguAAQhqAAhKg2QgxgjgRgsQgjAFgmAAQhlAAhHgkQgagMgQgPIgEAAQglAAgdgNQgKADgMAAIgBAAIABAAQAUAKAAAPQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgbQAAgaASgSQATgTAaAAIAGABQAFgLAJgJQAVgVAeAAIABAAIABgBQAjgZAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTgBQBqAABLA1QBLA2AABLQAAAagJAXIARgBQBNAAA4A3QA3A3AABNQgBAngNAhQARADAMAIQAVANAAASQAAAGgCAEIAFAEQAgAcABAnQAAAhgXAZQAdAuAAA+QAABHgoAzQgjAtgwAGQgEAjgmAaQgrAdg8AAQgYAAgUgFQgNALgUAJQg3AZhOAAQhNAAg3gZgAgRF0QAKgNAUgKQApgVA6AAQA6AAApAVQATAJAKAMQALgUAXgQQArgcA8AAIAEAAIgFgSQghARgpABQhDgBguguQgvgvAAhDIAAgHIgXABQg2ABgngXQgLgHgHgHQgiANgrAAQgvAAgjgOQgEALgGAKQgLASgNAJQgBBPggA8QAIADAHAFQARALAFAOIAHAAQAiAAAXAOQATAMADAQIATAAQAiAAAZAIg");
	var mask_graphics_13 = new cjs.Graphics().p("AAjIGQgrgUgJgbQgVgCgQgJQgJgFgFgGIgOABQggAAgXgKQgUgJgCgLIgPABQghAAgXgPQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhdAphBQArhCA6AAQAfAAAaARQAWgjAgAAQAgAAAYAlQANAWAFAbQAhgLApAAQA3AAAmAUIAJAEQAlgSAxAAQA3ABAmAVIAFACQAJgFAKgEQgsgzAAhGQgBghALgeQgpALguAAQg7gBgygQQAHAQAAATQAAAngbAcQgbAbgnAAQgnAAgcgbQgbgcAAgnQAAgnAbgcQAYgXAggEQgcgagMgfQgjAFgmAAQhlAAhHgkQgagMgQgPIgEAAQglAAgdgNQgKADgMAAIgBAAIABAAQAUAKAAAPQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgbQAAgaASgSQATgTAaAAIAGABQAFgLAJgJQAVgVAeAAIABAAIABgBQAjgZAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTgBQBqAABLA1QBLA2AABLQAAAagJAXIARgBQBNAAA4A3QA3A3AABNQgBAngNAhQARADAMAIQAVANAAASQAAAGgCAEIAFAEQAgAcABAnQAAAhgXAZQAdAuAAA+QAABHgoAzQgjAtgwAGQgEAjgmAaQgrAdg8AAQgYAAgUgFQgNALgUAJQg3AZhOAAQhNAAg3gZgAgRF0QAKgNAUgKQApgVA6AAQA6AAApAVQATAJAKAMQALgUAXgQQArgcA8AAIAEAAIgFgSQghARgpABQhDgBguguQgvgvAAhDIAAgHIgXABQg2ABgngXQgLgHgHgHQgiANgrAAQgvAAgjgOQgEALgGAKQgLASgNAJQgBBPggA8QAIADAHAFQARALAFAOIAHAAQAiAAAXAOQATAMADAQIATAAQAiAAAZAIg");
	var mask_graphics_14 = new cjs.Graphics().p("AAjIGQgrgUgJgbQgVgCgQgJQgJgFgFgGIgOABQggAAgXgKQgUgJgCgLIgPABQghAAgXgPQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhdAphBQArhCA6AAQAfAAAaARQAWgjAgAAQAbAAAUAZQAEgPAKgNQgSgYAAggQAAgnAbgcQAYgXAggEQgcgagMgfQgjAFgmAAQhlAAhHgkQgagMgQgPIgEAAQglAAgdgNQgKADgMAAIgBAAIABAAQAUAKAAAPQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgbQAAgaASgSQATgTAaAAIAGABQAFgLAJgJQAVgVAeAAIABAAIABgBQAjgZAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTgBQBqAABLA1QBLA2AABLQAAAagJAXIARgBQBNAAA4A3QA3A3AABNQgBAngNAhQARADAMAIQAVANAAASQAAAGgCAEIAFAEQAgAcABAnQAAAhgXAZQAdAuAAA+QAABHgoAzQgjAtgwAGQgEAjgmAaQgrAdg8AAQgYAAgUgFQgNALgUAJQg3AZhOAAQhNAAg3gZgAgRF0QAKgNAUgKQApgVA6AAQA6AAApAVQATAJAKAMQALgUAXgQQArgcA8AAIAEAAIgFgSQghARgpABQhDgBguguQgvgvAAhDIAAgHIgXABQg2ABgngXQgLgHgHgHQgiANgrAAQgvAAgjgOQgEALgGAKQgLASgNAJQgBBPggA8QAIADAHAFQARALAFAOIAHAAQAiAAAXAOQATAMADAQIATAAQAiAAAZAIgADUAHIAFACQAJgFAKgEQgsgzAAhGQgBghALgeQgpALguAAQg7gBgygQQAHAQAAATQAAAhgTAZQAOAXAAAcQAAATgHAQQAMAEALAGIAJAEQAlgSAxAAQA3ABAmAVg");
	var mask_graphics_15 = new cjs.Graphics().p("AAjIGQgrgUgJgbQgVgCgQgJQgJgFgFgGIgOABQggAAgXgKQgUgJgCgLIgPABQghAAgXgPQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhdAphBQArhCA6AAQAfAAAaARQAWgjAgAAQAbAAAUAZQAEgPAKgNQgSgYAAggQAAgnAbgcQAYgXAggEQgcgagMgfQgjAFgmAAQhlAAhHgkQgagMgQgPIgEAAQglAAgdgNQgKADgMAAIgBAAIABAAQAUAKAAAPQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgbQAAgaASgSQATgTAaAAIAGABQAFgLAJgJQAVgVAeAAIABAAIABgBQAjgZAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTgBQBqAABLA1QBLA2AABLQAAAagJAXIARgBQBNAAA4A3QA3A3AABNQgBAngNAhQARADAMAIQAVANAAASQAAAGgCAEIAFAEQAgAcABAnQAAAhgXAZQAdAuAAA+QAABHgoAzQgjAtgwAGQgEAjgmAaQgrAdg8AAQgYAAgUgFQgNALgUAJQg3AZhOAAQhNAAg3gZgAgRF0QAKgNAUgKQApgVA6AAQA6AAApAVQATAJAKAMQALgUAXgQQArgcA8AAIAEAAIgFgSQghARgpABQhDgBguguQgvgvAAhDIAAgHIgXABQgaABgXgGQAEAQAAATQAAA7gqAqQgpAqg7AAQg7AAgqgqQgRgRgKgTQgIAdgOAaQAIADAHAFQARALAFAOIAHAAQAiAAAXAOQATAMADAQIATAAQAiAAAZAIgADUAHIAFACQAJgFAKgEQgsgzAAhGQgBghALgeQgpALguAAQg7gBgygQQAHAQAAATQAAAhgTAZQAOAXAAAcQAAATgHAQQAMAEALAGIAJAEQAlgSAxAAQA3ABAmAVg");
	var mask_graphics_16 = new cjs.Graphics().p("AAjIGQgrgUgJgbQgVgCgQgJQgJgFgFgGIgOABQggAAgXgKQgUgJgCgLIgPABQghAAgXgPQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhdAphBQArhCA6AAQAfAAAaARQAWgjAgAAQAbAAAUAZQAEgPAKgNQgSgYAAggQAAgnAbgcQAYgXAggEQgcgagMgfQgjAFgmAAQhlAAhHgkQgagMgQgPIgEAAQglAAgdgNQgKADgMAAIgBAAIABAAQAUAKAAAPQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgbQAAgaASgSQATgTAaAAIAGABQAFgLAJgJQAVgVAeAAIABAAIABgBQAjgZAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTgBQBqAABLA1QBLA2AABLQAAAagJAXIARgBQBNAAA4A3QA3A3AABNQgBAngNAhQARADAMAIQAVANAAASQAAAGgCAEIAFAEQAgAcABAnQAAAhgXAZQAdAuAAA+QAABHgoAzQgjAtgwAGQgEAjgmAaQgrAdg8AAQgYAAgUgFQgNALgUAJQg3AZhOAAQhNAAg3gZgADTFdQATAJAKAMQALgUAXgQQArgcA8AAIAEAAIgFgSQghARgpABQhDgBguguQgvgvAAhDIAAgHIgXABQgaABgXgGQAEAQAAATQAAA3glAoQAiAaAAAkIgBAGQAUgDAWgBQA6AAApAVgAjaEhQAIADAHAFIALAIQAGgTASgQIgBAAQgRgRgKgTQgIAdgOAagADUAHIAFACQAJgFAKgEQgsgzAAhGQgBghALgeQgpALguAAQg7gBgygQQAHAQAAATQAAAhgTAZQAOAXAAAcQAAATgHAQQAMAEALAGIAJAEQAlgSAxAAQA3ABAmAVg");
	var mask_graphics_17 = new cjs.Graphics().p("AitIMQgsgsgBhAQAAgPADgNIgPgIQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhdAphBQArhCA6AAQAfAAAaASQAWgkAgAAQAbAAAUAaQAEgQAKgNQgSgYAAggQAAgnAbgbQAYgYAggDQgcgbgMgfQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQBNAAA4A3QA3A3AABOQgBAmgNAhQARADAMAIQAVANAAASQAAAGgCAGIAFADQAgAbABAoQAAAhgXAZQAdAuAAA9QAABIgoAzQgjAsgwAGQgEAkgmAZQgrAdg8AAQgYAAgUgEQgNAKgUAJQg3AahOAAQg7AAgvgPQgIALgLAKQgrAthAAAQg/AAgtgtgADTFDQATAJAKAMQALgUAXgPQArgdA8AAIAEAAIgFgSQghASgpAAQhDAAgugvQgvgvAAhCIAAgHIgXABQgaAAgXgGQAEARAAASQAAA3glApQAiAaAAAjIgBAGQAUgDAWAAQA6AAApAUgAjaEHQAIADAHAFIALAIQAGgTASgQIgBAAQgRgRgKgTQgIAdgOAagADUgSIAFADQAJgGAKgFQgsgzAAhFQgBgiALgdQgpAKguAAQg7AAgygRQAHAQAAATQAAAigTAZQAOAWAAAcQAAATgHARQAMAEALAFIAJAFQAlgSAxAAQA3AAAmAWg");
	var mask_graphics_18 = new cjs.Graphics().p("AiWHQQgmg0gYg9QgJgDgJgGQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhcAphCQArhCA6AAQAfAAAaASQAWgkAgAAQANAAAMAGQASglAYghQAiguAlgfQgmgfgOgmQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQA/ggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQBNAAA4A3QA3A3AABOQgBAmgNAhQARADAMAIQAVANAAASQAAAGgCAGIAFADQAgAcABAnQAAAhgXAZQAdAuAAA9QAABIgoAzQgjAsgwAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiRAAhoiPg");
	var mask_graphics_19 = new cjs.Graphics().p("AjpHQQgmg0gYg9QgJgDgJgGQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhcAphCQArhCA6AAQAfAAAaASQAWgkAgAAQANAAAMAGQASglAYghQAiguAlgfQgmgfgOgmQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQBAggBSAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQBNAAA4A3QA3A3AABOQgBAmgNAhQARADAMAIQAVANAAASQAAAGgCAGIAFADQAgAcABAnQAAAhgXAZQAOAVAHAZQAEhWAUhAQAahPAkAAQAlAAAZBPQAaBOAABvQAABwgaBPQgZBPglAAQgkAAgahPQgQg0gGhBQgJAngZAgQgjAsgwAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiRAAhoiPg");
	var mask_graphics_20 = new cjs.Graphics().p("AkeHQQgmg0gYg9QgKgDgIgGQgNgIgGgKIgNABQgiAAgZgQIgDgCIgEAAQg7AAgqhCQgphCAAhdQAAhcAphCQAqhCA7AAQAeAAAaASQAXgkAfAAQAOAAALAGQATglAYghQAhguAmgfQgmgfgPgmQgiAFgnAAQhkAAhIgjQgZgNgQgOIgFAAQgkAAgdgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgVAKgcAAQgdAAgWgKQgUgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgaASgTQASgSAbAAIAFAAQAFgLAKgJQAUgVAeAAIACAAIABAAQAjgaAyAAQAuAAAiAWQA8gVBOAAQBkAABHAjIADABQA/ggBTAAQBqAABKA1QBMA1gBBMQABAZgJAXIAQgBQA+AAAvAjQgMgRgBgVQAAghAhgXQAZgTAigDQAJgOARgKQAhgUAvAAQAuAAAgATQAdgPAoAAQApAAAdAQQAcAQAAAWQAAAXgcAPQgdAQgpAAQgdAAgXgIQgHAHgJAGQgaAPghAEQgFAYgZASQgSANgVAGQAHAMABAPQAXAAARALIAIAAQAfAAAWAOQAWAPAAAVQAAAVgWAPQgWAPgfAAQgfAAgWgPIgKgIQgSgDgOgKIAAAAQgJADgJABIAAAJQAAAmgOAhQARADANAIQAVANgBASQABAGgDAGIAFADQAhAcAAAnQAAAhgXAZQAOAVAHAZQAEhWAVhAQAahPAkAAQAkAAAZBPQAaBOAABvQAABwgaBPQgZBPgkAAQgkAAgahPQgRg0gGhBQgJAngZAgQgjAsgwAGQgDAkgmAZQgrAdg9AAIgLAAIgRAZQhoCPiRAAQiSAAhniPgAJMiYQgIgBAAgDQAAgCAIgCQAJgCALAAQAMAAAHACQAJACAAACQAAADgJABQgHACgMAAQgLAAgJgCg");
	var mask_graphics_21 = new cjs.Graphics().p("AlNHQQgmg0gYg9QgKgDgIgGQgNgIgGgKIgNABQgiAAgZgQIgDgCIgEAAQg7AAgqhCQgphCAAhdQAAhcAphCQAqhCA7AAQAeAAAaASQAXgkAfAAQAOAAALAGQATglAYghQAhguAmgfQgmgfgPgmQgiAFgnAAQhkAAhIgjQgZgNgQgOIgFAAQgkAAgdgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgVAKgcAAQgdAAgWgKQgUgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgaASgTQASgSAbAAIAFAAQAFgLAKgJQAUgVAeAAIACAAIABAAQAjgaAyAAQAuAAAiAWQA8gVBOAAQBkAABHAjIADABQA/ggBTAAQBqAABKA1QBMA1gBBMQABAZgJAXIAQgBQAsAAAkASQAHgSALgRQAGgYAZgSQAHgGAJgEIAGgFQBThDB0AAQBGAAA5AYQATAEAPAIQAOAIAHAKIASANQBUBDAABfQAABehUBDQhBA1hXALIAIAYQAaBOAABvQAABwgaBPQgZBPgkAAQgkAAgahPQgRg0gGhBQgJAngZAgQgjAsgwAGQgDAkgmAZQgrAdg9AAIgLAAIgRAZQhoCPiRAAQiSAAhniPgAGjhHQABAGgDAGIAFADQAhAcAAAnQAAAhgXAZQAOAVAHAZQAEhWAVhAIAJgZQgkgGghgOIABAJg");
	var mask_graphics_22 = new cjs.Graphics().p("AnMHQQgmg0gYg9QgKgDgIgGQgNgIgFgKIgOABQgiAAgZgQIgDgCIgEAAQg7AAgqhCQgphCAAhdQAAhcAphCQAqhCA7AAQAfAAAZASQAXgkAgAAQANAAALAGQATglAYghQAhguAmgfQgmgfgOgmQgjAFgnAAQhkAAhHgjQgagNgQgOIgFAAQgkAAgdgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgUAKgdAAQgdAAgVgKQgVgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAdAAIACAAIABAAQAjgaAyAAQAvAAAhAWQA9gVBNAAQBlAABHAjIACABQBAggBTAAQBqAABLA1QBKA1AABMQAAAZgJAXIARgBQArAAAkASQAIgSAKgRQAGgYAZgSQAIgGAIgEIAGgFQBThDB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBTBDAABfQAABehTBDQhCA1hXALIAJAYQAaBOAABvQAABwgaBPQgaBPgkAAQgkAAgahPQgQg0gGhBQgKAngZAgQgjAsgvAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhmCPiSAAQiSAAhoiPgAElhHQAAAGgDAGIAFADQAhAcAAAnQAAAhgWAZQANAVAHAZQAEhWAVhAIAKgZQglgGghgOIACAJgAK3AIQgtgTAAgcQAAgcAtgUQAtgTA/AAQA/AAAsATQAtAUAAAcQAAAcgtATQgsAUg/AAQg/AAgtgUg");
	var mask_graphics_23 = new cjs.Graphics().p("AnMHQQgmg0gYg9QgKgDgIgGQgNgIgFgKIgOABQgiAAgZgQIgDgCIgEAAQg7AAgqhCQgphCAAhdQAAhcAphCQAqhCA7AAQAfAAAZASQAXgkAgAAQANAAALAGQATglAYghQAhguAmgfQgmgfgOgmQgjAFgnAAQhkAAhHgjQgagNgQgOIgFAAQgkAAgdgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgUAKgdAAQgdAAgVgKQgVgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAdAAIACAAIABAAQAjgaAyAAQAvAAAhAWQA9gVBNAAQBlAABHAjIACABQBAggBTAAQBqAABLA1QBKA1AABMQAAAZgJAXIARgBQArAAAkASQAIgSAKgRQAGgYAZgSQAIgGAIgEIAGgFQBThDB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBTBDAABfQAABehTBDIgSANQAbgFAdAAQAwAAAnAOQAbgFAgAAQA/AAAsATQAtAUAAAcQAAAcgtATQgfAOgoAEIgCAIIAAAAIAIAHIAEAAQAaAAASASQATASAAAaQAAAKgDAIIAHAMQAQAhAAAvQAAAvgQAiQgRAhgXAAQgXAAgQghQgRgiAAgvQAAgcAGgYQgMgEgJgKIgGgHQgKACgKAAQgiAAgYgTQgIAIgMAAQgMAAgJgJIgCgBIgVAAQgoAAgigJIgEADQghAZgtAFIAAAJQAABwgaBPQgaBPgkAAQgkAAgahPQgQg0gGhBQgKAngZAgQgjAsgvAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhmCPiSAAQiSAAhoiPgAElhHQAAAGgDAGIAFADQAhAcAAAnQAAAhgWAZQANAVAHAZQAEhWAVhAIAKgZQglgGghgOIACAJgAH0hBIAFABIACgCIgHABg");
	var mask_graphics_24 = new cjs.Graphics().p("AnMHQQgmg0gYg9QgKgDgIgGQgNgIgFgKIgOABQgiAAgZgQIgDgCIgEAAQg7AAgqhCQgphCAAhdQAAhcAphCQAqhCA7AAQAfAAAZASQAXgkAgAAQANAAALAGQATglAYghQAhguAmgfQgmgfgOgmQgjAFgnAAQhkAAhHgjQgagNgQgOIgFAAQgkAAgdgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgUAKgdAAQgdAAgVgKQgVgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAdAAIACAAIABAAQAjgaAyAAQAvAAAhAWQA9gVBNAAQBlAABHAjIACABQBAggBTAAQBqAABLA1QBKA1AABMQAAAZgJAXIARgBQArAAAkASQAIgSAKgRQAGgYAZgSQAIgGAIgEIAGgFQBThDB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBTBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFQAtAUAAAcQAAASgTAPQAQAzAAA8QAABEgVA6QgCAkgNAbQgQAggWABIgGAIQhRBfhyAAQhyAAhQhfIgEgEIgEAOQgaBPgkAAQgkAAgahPQgQg0gGhBQgKAngZAgQgjAsgvAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhmCPiSAAQiSAAhoiPgAElhHQAAAGgDAGIAFADQAhAcAAAnQAAAhgWAZQANAVAHAZQAEhWAVhAIAKgZQglgGghgOIACAJg");
	var mask_graphics_25 = new cjs.Graphics().p("AoTHQQgmg0gYg9QgKgDgJgGQgMgIgGgKIgNABQgjAAgYgQIgDgCIgEAAQg7AAgqhCQgqhCAAhdQAAhcAqhCQAqhCA7AAQAeAAAaASQAXgkAfAAQANAAAMAGQASglAZghQAhguAlgfQglgfgPgmQgiAFgnAAQhlAAhHgjQgZgNgRgOIgEAAQglAAgcgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAIgHIgDgDQgTgSAAgaQAAgaATgTQASgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAkgaAyAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgIAXIAQgBQArAAAkASQAHgSALgRQAFgYAZgSQAIgGAIgEIAGgFQBThDB1AAQBGAAA5AYQASAEAPAIQAPAIAHAKIASANQBTBDAABfQAAAigLAfQBqAFBLBZQANAQALARIAPAFQAtAUAAAcQAAASgTAPQAQAzAAA8QAAAXgDAXQAGgXAJgUQAXgyAgAAQAhAAAXAyQAXAzAABHQAABHgXAyQgXAyghAAQggAAgXgyQgXgyAAhHQAAgVABgSQgEAVgHATQgCAkgOAbQgQAggVABIgHAIQhQBfhyAAQhyAAhRhfIgDgEIgFAOQgZBPgkAAQgkAAgahPQgRg0gGhBQgJAngZAgQgjAsgwAGQgEAkgmAZQgqAdg8AAIgLAAIgSAZQhnCPiSAAQiSAAhniPgADdhHQAAAGgCAGIAFADQAhAcAAAnQAAAhgXAZQAOAVAHAZQAEhWAVhAIAJgZQgkgGghgOIABAJg");
	var mask_graphics_26 = new cjs.Graphics().p("AptHQQgmg0gYg9QgJgDgJgGQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhcAphCQArhCA6AAQAfAAAaASQAWgkAgAAQANAAAMAGQASglAYghQAiguAlgfQgmgfgOgmQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQArAAAlASQAHgSAKgRQAFgYAZgSQAIgGAIgEIAGgFQBThDB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBTBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFQAuAUgBAcQAAASgSAPQAQAzgBA8QAAAXgCAXQAFgWAJgUQgCgVAAgYQAAhRAgg6QAhg6AuAAQAvAAAgA6QAgA3ACBLQAWAKASAhQAQAeAGAmQAFAHAFAJQATAlAAAzQAAA0gTAkQgTAkgbAAQgYAAgSgdIgCAAQgjAAgZguQgIgQgFgSQgGAkgNAeQgYAyggAAQggAAgYgyQgWgyAAhHQAAgVABgSQgEAVgHATQgDAkgNAbQgQAggWABIgGAIQhQBfhzAAQhyAAhQhfIgEgEIgEAOQgZBPglAAQgkAAgahPQgQg0gGhBQgJAngZAgQgjAsgwAGQgEAkgmAZQgqAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPgACEhHQAAAGgCAGIAFADQAgAcABAnQAAAhgXAZQAOAVAHAZQAEhWAUhAIAKgZQglgGgggOIABAJg");
	var mask_graphics_27 = new cjs.Graphics().p("AqdHQQgmg0gYg9QgKgDgIgGQgNgIgFgKIgOABQgiAAgZgQIgDgCIgEAAQg7AAgqhCQgphCAAhdQAAhcAphCQAqhCA7AAQAfAAAZASQAXgkAgAAQANAAALAGQATglAYghQAhguAmgfQgmgfgOgmQgjAFgnAAQhkAAhHgjQgagNgQgOIgFAAQgkAAgdgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgUAKgdAAQgdAAgVgKQgVgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAdAAIACAAIABAAQAjgaAyAAQAvAAAhAWQA9gVBNAAQBlAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQArAAAkASQAIgSAKgRQAGgYAZgSQAIgGAHgEIAGgFQBThDB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBTBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFIAQAIQAOgbASgaQBIhhBkAAQBlAABHBhQBHBiAACJQAACKhHBiQhHBihlAAQg8AAgygkQghAAgXgyIgEgKIgCgCQgVgdgPghIgGARQgQAggWABIgGAIQhRBfhyAAQhyAAhQhfIgEgEIgEAOQgaBPgkAAQgkAAgahPQgQg0gGhBQgKAngZAgQgjAsgvAGQgDAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPgABUhHQAAAGgDAGIAFADQAhAcAAAnQAAAhgWAZQANAVAHAZQAEhWAVhAIAKgZQglgGghgOIACAJg");
	var mask_graphics_28 = new cjs.Graphics().p("As8HQQgmg0gYg9QgJgDgJgGQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhcAphCQArhCA6AAQAfAAAaASQAWgkAgAAQANAAAMAGQASglAYghQAiguAlgfQgmgfgOgmQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQArAAAlASQAHgSALgRQAFgYAZgSQAIgGAIgEIAGgFQBThDB0AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBTBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFIAQAIQAOgbATgaQBHhhBlAAQBkAABHBhQBIBiAACJQAAAlgGAiIAHgBIAEAAIAIgFQAMgGAOgCQgEgRAAgUQAAgdAJgVQAHgSAKgDQgCgEAAgGQAAgUAUgOIAFgDIAAgLQAAglALgaQAMgZASAAQAOAAALAUQANABAKAOQALAQAAAXQAAAUgIANQANANABAQQgBAUgSAOQgKAHgMAEQAEAIAAAKQAAASgNANQAAAYgFATIAXgBQAdAAAYAHQAOgHAQAAQAcAAAUAUQATATAAAcIgBANQAKAVAAAYQAAA0guAlQgvAkhCAAQhBAAgvgkQgkgdgIgmIgBAAQgdAAgWgUQgKARgMARQhHBihkAAQg9AAgygkQggAAgYgyIgDgKIgCgCQgVgdgPghIgHARQgQAggWABIgGAIQhQBfhzAAQhyAAhQhfIgEgEIgEAOQgZBPglAAQgkAAgZhPQgQg0gGhBQgJAngZAgQgjAsgwAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPgAhKhHQAAAGgCAGIAFADQAgAcABAnQAAAhgXAZQAOAVAHAZQAEhWAUhAIAKgZQglgGgggOIABAJg");
	var mask_graphics_29 = new cjs.Graphics().p("AtiHQQgmg0gYg9QgKgDgIgGQgNgIgFgKIgOABQgiAAgZgQIgDgCIgEAAQg7AAgqhCQgphCAAhdQAAhcAphCQAqhCA7AAQAfAAAZASQAXgkAgAAQANAAALAGQATglAYghQAhguAmgfQgmgfgOgmQgjAFgnAAQhkAAhHgjQgagNgQgOIgFAAQgkAAgdgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgUAKgdAAQgdAAgVgKQgVgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAdAAIACAAIABAAQAjgaAyAAQAvAAAhAWQA9gVBNAAQBlAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQArAAAkASQAIgSAKgRQAGgYAZgSQAIgGAIgEIAGgFQBThDB0AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBTBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFIAQAIQAOgbASgaQBIhhBkAAQBlAABHBhQBHBiAACJQAAAlgFAiIAHgBIAEAAIAIgFQAMgGAOgCQgEgRAAgUQAAgdAIgVQAIgSAKgDQgCgEAAgGQAAgIAEgIIgSgIQg8gcAAgqQAAgpA8geQA8gdBUAAQBVAAA7AdQA8AeAAApQAAAqg8AcQg7AehVAAIAAAAQgCAQgRAMQgJAHgMAEQAEAIAAAKQAAASgNANQAAAYgFATIAXgBQAcAAAZAHQANgHARAAQAcAAATAUQAUATAAAcIgBANQAKAVAAAYQAAA0gvAlQguAkhCAAQhBAAgvgkQgkgdgIgmIgBAAQgeAAgVgUQgKARgMARQhHBihlAAQg8AAgygkQghAAgXgyIgEgKIgCgCQgVgdgPghIgGARQgQAggWABIgGAIQhRBfhyAAQhyAAhQhfIgEgEIgEAOQgaBPgkAAQgjAAgahPQgQg0gGhBQgKAngZAgQgjAsgvAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPgAhwhHQAAAGgDAGIAFADQAhAcAAAnQAAAhgWAZQANAVAHAZQAEhWAVhAIAKgZQglgGghgOIACAJg");
	var mask_graphics_30 = new cjs.Graphics().p("AtiHQQgmg0gYg9QgKgDgIgGQgNgIgFgKIgOABQgiAAgZgQIgDgCIgEAAQg7AAgqhCQgphCAAhdQAAhcAphCQAqhCA7AAQAfAAAZASQAXgkAgAAQANAAALAGQATglAYghQAhguAmgfQgmgfgOgmQgjAFgnAAQhkAAhHgjQgagNgQgOIgFAAQgkAAgdgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgUAKgdAAQgdAAgVgKQgVgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAdAAIACAAIABAAQAjgaAyAAQAvAAAhAWQA9gVBNAAQBlAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQArAAAkASQAIgSAKgRQAGgYAZgSQAIgGAIgEIAGgFQBThDB0AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBTBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFIAQAIQAOgbASgaQBIhhBkAAQBlAABHBhQA5BPALBnQAJgHAKgHQAPgJARgIIgCgBQg8gcAAgqQAAgpA8geQA8gdBUAAQBVAAA7AdQA8AeAAApQAAAqg8AcQgWALgaAHIABAAQA4AkAAAzQAAAvgxAiQAPARAAAYIgBANQAKAVAAAYQAAA0gvAlQguAkhCAAQhBAAgvgkQgkgdgIgmIgBAAQgeAAgVgUQgKARgMARQhHBihlAAQg8AAgygkQghAAgXgyIgEgKIgCgCQgVgdgPghIgGARQgQAggWABIgGAIQhRBfhyAAQhyAAhQhfIgEgEIgEAOQgaBPgkAAQgjAAgahPQgQg0gGhBQgKAngZAgQgjAsgvAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPgAhwhHQAAAGgDAGIAFADQAhAcAAAnQAAAhgWAZQANAVAHAZQAEhWAVhAIAKgZQglgGghgOIACAJg");
	var mask_graphics_31 = new cjs.Graphics().p("Au4HQQgmg0gYg9QgKgDgIgGQgNgIgGgKIgNABQgiAAgZgQIgDgCIgEAAQg7AAgqhCQgphCAAhdQAAhcAphCQAqhCA7AAQAeAAAaASQAXgkAfAAQAOAAALAGQATglAYghQAhguAmgfQgmgfgPgmQgiAFgnAAQhkAAhIgjQgZgNgQgOIgFAAQgkAAgdgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgVAKgcAAQgdAAgWgKQgUgKAAgPQAAgJAIgHIgDgDQgSgSAAgaQAAgaASgTQASgSAbAAIAFAAQAFgLAKgJQAUgVAeAAIACAAIABAAQAjgaAyAAQAuAAAiAWQA8gVBOAAQBkAABHAjIADABQA/ggBTAAQBrAABKA1QBMA1gBBMQABAZgJAXIAQgBQAsAAAkASQAHgSALgRQAGgYAZgSQAHgGAJgEIAFgFQBUhDB0AAQBGAAA4AYQATAEAOAIQAPAIAHAKIASANQBUBDAABfQAAAigMAfQBqAFBMBZQANAQALARIAOAFIAQAIQAOgbASgaQBHhhBlAAQBkAABHBhQA6BPALBnQAIgHAKgHQAQgJARgIIgDgBQg7gcAAgqQAAgpA7geQA9gdBUAAQBUAAA8AdQA8AeAAApQAAAqg8AcQgWALgaAHIAAAAQA4AkAAAzQAAAvgwAiQAPARAAAYIgCANQALAVAAAYQgBA0guAlQgvAkhBAAQhBAAgvgkQgkgdgIgmIgBAAQgeAAgVgUQgLARgMARQhHBihkAAQg9AAgygkQggAAgXgyIgEgKIgCgCQgVgdgPghIgHARQgPAggWABIgGAIQhRBfhyAAQhyAAhQhfIgDgEIgFAOQgZBPgkAAQgkAAgahPQgRg0gGhBQgJAngZAgQgjAsgwAGQgDAkgmAZQgrAdg9AAIgLAAIgRAZQhoCPiSAAQiSAAhniPgAjHhHQABAGgDAGIAFADQAhAcAAAnQAAAhgXAZQAOAVAHAZQAEhWAVhAIAJgZQgkgGghgOIABAJgAUlAUQgWgWgBgfQABggAWgWIAJgIQAAgRARgMQASgNAZAAQAZAAARANQASANAAASQABANgJAKQAKAQgBAVQABAfgXAWQgWAWggAAQgfAAgXgWg");
	var mask_graphics_32 = new cjs.Graphics().p("AvAHQQgmg0gYg9QgKgDgJgGQgMgIgGgKIgNABQgjAAgYgQIgDgCIgEAAQg7AAgqhCQgqhCAAhdQAAhcAqhCQAqhCA7AAQAeAAAaASQAXgkAfAAQANAAAMAGQATglAYghQAhguAmgfQgmgfgPgmQgiAFgnAAQhlAAhHgjQgZgNgRgOIgEAAQglAAgcgOQgLADgMAAIgBAAIABABQAVAKAAAOQAAAPgVAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAIgHIgDgDQgTgSAAgaQAAgaATgTQASgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIACAAIAAAAQAkgaAyAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgIAXIAQgBQAsAAAkASQAHgSALgRQAFgYAZgSQAIgGAJgEIAFgFQBThDB1AAQBGAAA4AYQASAEAPAIQAPAIAHAKIASANQBTBDAABfQAAAigLAfQBqAFBLBZQAOAQALARIAOAFIAQAIQAOgbASgaQBHhhBlAAQBkAABHBhQA6BPALBnQAIgHAKgHQAQgJARgIIgDgBQg7gcAAgqQAAgpA7geQA8gdBVAAQBUAAA8AdQA8AeAAApQAAAMgFALQALgJAOgEQADgaATgTIAIgIQABgRARgMQASgNAZAAQAZAAARANQASANAAASQAAANgIAKQAJAQAAAVQAAAfgWAWQgRARgWAEQgEAVgQAPQgMAMgQAGIABARQAAAsgNAgQAQAdAvADQAuADATAbQATAcgUA5QgUA5hCgqQhDgqgNgNQgMgNgEgGQgIAHgJAAQgPAAgLgTQgLgTAAgaQAAgbALgTIACgDQgFgTgCgYQgCAsguAhQAOARAAAYIgBANQAKAVAAAYQAAA0guAlQgvAkhBAAQhCAAgugkQgkgdgIgmIgBAAQgeAAgWgUQgKARgMARQhHBihkAAQg9AAgygkQggAAgXgyIgEgKIgCgCQgVgdgPghIgHARQgQAggVABIgHAIQhQBfhyAAQhyAAhQhfIgDgEIgFAOQgZBPgkAAQgkAAgahPQgRg0gGhBQgJAngZAgQgjAsgwAGQgDAkgnAZQgqAdg9AAIgLAAIgSAZQhnCPiSAAQiSAAhniPgAjPhHQAAAGgCAGIAFADQAhAcAAAnQAAAhgXAZQAOAVAHAZQAEhWAVhAIAJgZQgkgGghgOIABAJgAS3ASQgWALgaAHIAAAAQAzAhAFAtIAAgCQAAg0ARgkIADgHQACgLAEgIQgOAKgUAKg");
	var mask_graphics_33 = new cjs.Graphics().p("Ax0HQQgmg0gYg9QgJgDgJgGQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhcAphCQArhCA6AAQAfAAAaASQAWgkAgAAQANAAAMAGQASglAYghQAiguAlgfQgmgfgOgmQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQArAAAlASQAHgSALgRQAFgYAZgSQAIgGAIgEIAGgFQBThDB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBSBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFIAQAIQAOgbATgaQBHhhBlAAQBkAABHBhQA5BPAMBnQAIgHAKgHQAPgJARgIIgCgBQg7gcgBgqQABgpA7geQA8gdBVAAQBUAAA8AdQA7AeABApQAAAMgFALQALgJAOgEQACgaATgTIAJgIQABgRAQgMQASgNAaAAQAZAAARANQASANAAASQAAANgIAKQAJAQAAAVQAAAfgXAWQgRARgWAEQgEAVgPAPQgNAMgPAGIABARQAAAsgNAgQAQAdAuADQAgACATANQAUgIAXgFQgcg3AAhGQAAhhA2hEQA2hFBMAAQBMAAA2BFQA2BEAABhQAABig2BFQgnAxgyAOQgKAWgfASQgsAZhAAAQg/AAgtgZQgWAEghgVQhDgqgNgNQgNgNgEgGQgHAHgJAAQgPAAgMgTQgKgTgBgaQABgbAKgTIACgDQgFgTgBgYQgCAsguAhQAOARAAAYIgBANQAKAVAAAYQAAA0guAlQgvAkhCAAQhBAAgvgkQgkgdgIgmIgBAAQgdAAgWgUQgKARgMARQhHBihkAAQg9AAgygkQggAAgYgyIgDgKIgCgCQgVgdgPghIgHARQgQAggWABIgGAIQhQBfhyAAQhyAAhQhfIgEgEIgEAOQgZBPglAAQgkAAgahPQgQg0gGhBQgJAngZAgQgjAsgwAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPgAmChHQAAAGgCAGIAFADQAgAcABAnQAAAhgXAZQAOAVAHAZQAEhWAUhAIAKgZQglgGgggOIABAJgAQEASQgXALgZAHIAAAAQAzAhAFAtIAAgCQgBg0ASgkIADgHQABgLAFgIQgOAKgUAKg");
	var mask_graphics_34 = new cjs.Graphics().p("Ax0HQQgmg0gYg9QgJgDgJgGQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhcAphCQArhCA6AAQAfAAAaASQAWgkAgAAQANAAAMAGQASglAYghQAiguAlgfQgmgfgOgmQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQArAAAlASQAHgSALgRQAFgYAZgSQAIgGAIgEIAGgFQBThDB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBSBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFIAQAIQAOgbATgaQBHhhBlAAQBkAABHBhQA5BPAMBnQAIgHAKgHQAPgJARgIIgCgBQg7gcgBgqQABgpA7geQA8gdBVAAQBUAAA8AdQA7AeABApQAAAMgFALQALgJAOgEQACgaATgTIAJgIQABgRAQgMQASgNAaAAQAZAAARANQASANAAASQAAANgIAKQAHAMABAOQAVADASAHQAKgSANgQQA2hFBMAAQBMAAA2BFQA2BEAABhQAABig2BFQgnAxgyAOQgKAWgfASQgsAZhAAAQg/AAgtgZQgWAEghgVQhDgqgNgNQgNgNgEgGQgHAHgJAAQgPAAgMgTQgKgTgBgaQABgbAKgTIACgDQgFgTgBgYQgCAsguAhQAOARAAAYIgBANQAKAVAAAYQAAA0guAlQgvAkhCAAQhBAAgvgkQgkgdgIgmIgBAAQgdAAgWgUQgKARgMARQhHBihkAAQg9AAgygkQggAAgYgyIgDgKIgCgCQgVgdgPghIgHARQgQAggWABIgGAIQhQBfhyAAQhyAAhQhfIgEgEIgEAOQgZBPglAAQgkAAgahPQgQg0gGhBQgJAngZAgQgjAsgwAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPgAmChHQAAAGgCAGIAFADQAgAcABAnQAAAhgXAZQAOAVAHAZQAEhWAUhAIAKgZQglgGgggOIABAJgAQEASQgXALgZAHIAAAAQAzAhAFAtIAAgCQgBg0ASgkIADgHQABgLAFgIQgOAKgUAKg");
	var mask_graphics_35 = new cjs.Graphics().p("Ax0HQQgmg0gYg9QgJgDgJgGQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhcAphCQArhCA6AAQAfAAAaASQAWgkAgAAQANAAAMAGQASglAYghQAiguAlgfQgmgfgOgmQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQArAAAlASQAHgSALgRQAFgYAZgSQAIgGAIgEIAGgFQBThDB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBSBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFIAQAIQAOgbATgaQBHhhBlAAQBkAABHBhQA5BPAMBnQAIgHAKgHQAPgJARgIIgCgBQg7gcgBgqQABgpA7geQA8gdBVAAQBUAAA8AdQA7AeABApQAAAMgFALQALgJAOgEQACgaATgTIAJgIQABgRAQgMQASgNAaAAQAZAAARANQASANAAASQAAANgIAKQAHAMABAOQAVADASAHQAKgSANgQQA2hFBMAAQBMAAA2BFQA2BEAABhQAABig2BFQgnAxgyAOQgKAWgfASQgsAZhAAAQg/AAgtgZIgEAAQgIAUgQAQQgeAfgrAAQgsAAgegfQgegegBgrQABggAQgZIgGgJQgKgTgBgaQABgbAKgTIACgDQgFgTgBgYQgCAsguAhQAOARAAAYIgBANQAKAVAAAYQAAA0guAlQgvAkhCAAQhBAAgvgkQgkgdgIgmIgBAAQgdAAgWgUQgKARgMARQhHBihkAAQg9AAgygkQggAAgYgyIgDgKIgCgCQgVgdgPghIgHARQgQAggWABIgGAIQhQBfhyAAQhyAAhQhfIgEgEIgEAOQgZBPglAAQgkAAgahPQgQg0gGhBQgJAngZAgQgjAsgwAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPgAmChHQAAAGgCAGIAFADQAgAcABAnQAAAhgXAZQAOAVAHAZQAEhWAUhAIAKgZQglgGgggOIABAJgAQEASQgXALgZAHIAAAAQAzAhAFAtIAAgCQgBg0ASgkIADgHQABgLAFgIQgOAKgUAKg");
	var mask_graphics_36 = new cjs.Graphics().p("Ax0HQQgmg0gYg9QgJgDgJgGQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhcAphCQArhCA6AAQAfAAAaASQAWgkAgAAQANAAAMAGQASglAYghQAiguAlgfQgmgfgOgmQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQArAAAlASQAHgSALgRQAFgYAZgSQAIgGAIgEIAGgFQBThDB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBSBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFIAQAIQAOgbATgaQBHhhBlAAQBkAABHBhQA5BPAMBnQAIgHAKgHQAPgJARgIIgCgBQg7gcgBgqQABgpA7geQA8gdBVAAQBUAAA8AdQA7AeABApQAAAMgFALQALgJAOgEQACgaATgTIAJgIQABgRAQgMQASgNAaAAQAZAAARANQASANAAASQAAANgIAKQAHAMABAOQAVADASAHQAKgSANgQQA2hFBMAAQBMAAA2BFQA2BEAABhQAABig2BFQgnAxgyAOQgKAWgfASQgsAZhAAAQg/AAgtgZIgEAAQgFANgJAMQAIAUAAAWQAAAzgoAkQgmAkg4AAQg4AAgngkQgngkAAgzQAAgXAIgUIAAABQgvAkhCAAQhBAAgvgkQgkgdgIgmIgBAAQgdAAgWgUQgKARgMARQhHBihkAAQg9AAgygkQggAAgYgyIgDgKIgCgCQgVgdgPghIgHARQgQAggWABIgGAIQhQBfhyAAQhyAAhQhfIgEgEIgEAOQgZBPglAAQgkAAgahPQgQg0gGhBQgJAngZAgQgjAsgwAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPgAPcDMQAOARAAAYIgBANQAKAVAAAYQAAAUgHASQAMgKANgGQACgdAPgXIgGgJQgKgTgBgaQABgbAKgTIACgDQgFgTgBgYQgCAsguAhgAmChHQAAAGgCAGIAFADQAgAcABAnQAAAhgXAZQAOAVAHAZQAEhWAUhAIAKgZQglgGgggOIABAJgAQEASQgXALgZAHIAAAAQAzAhAFAtIAAgCQgBg0ASgkIADgHQABgLAFgIQgOAKgUAKg");
	var mask_graphics_37 = new cjs.Graphics().p("APfJOQgigbAAgmQABgYAOgUQgPgaAAgfQAAgXAIgUIAAABQgvAkhCAAQhBAAgvgkQgkgdgIgmIgBAAQgdAAgWgUQgKARgMARQhHBihkAAQg9AAgygkQggAAgYgyIgDgKIgCgCQgVgdgPghIgHARQgQAggWABIgGAIQhQBfhyAAQhyAAhQhfIgEgEIgEAOQgZBPglAAQgkAAgahPQgQg0gGhBQgJAngZAgQgjAsgwAGQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPQgmg0gYg9QgJgDgJgGQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhcAphCQArhCA6AAQAfAAAaASQAWgkAgAAQANAAAMAGQASglAYghQAiguAlgfQgmgfgOgmQgjAFgmAAQhlAAhHgjQgagNgQgOIgEAAQglAAgdgOQgKADgMAAIgBAAIABABQAUAKAAAOQAAAPgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgPQAAgJAHgHIgDgDQgSgSAAgaQAAgaASgTQATgSAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAWQA8gVBOAAQBkAABHAjIACABQBAggBTAAQBqAABLA1QBLA1AABMQAAAZgJAXIARgBQArAAAlASQAHgSALgRQAFgYAZgSQAIgGAIgEIAGgFQBThDB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASANQBSBDAABfQAAAigLAfQBpAFBMBZQANAQALARIAOAFIAQAIQAOgbATgaQBHhhBlAAQBkAABHBhQA5BPAMBnQAIgHAKgHQAPgJARgIIgCgBQg7gcgBgqQABgpA7geQA8gdBVAAQBUAAA8AdQA7AeABApQAAAMgFALQALgJAOgEQACgaATgTIAJgIQABgRAQgMQASgNAaAAQAZAAARANQASANAAASQAAANgIAKQAHAMABAOQAVADASAHQAKgSANgQQA2hFBMAAQBMAAA2BFQA2BFAABgQAABig2BFQgnAxgyAOQgKAWgfASQgsAZhAAAQg/AAgtgZIgEAAQgFANgJAMQAIAUAAAWQAAAzgoAkIgDADIAAALQABAmgiAbQggAbgvAAQguAAghgbgAPcDCQAOARAAAYIgBANQAKAVAAAYQAAAUgHASQAMgKANgGQACgdAPgXIgGgJQgKgTgBgaQABgbAKgTIACgDQgFgTgBgYQgCAsguAhgAmChRQAAAGgCAGIAFADQAgAcABAnQAAAhgXAZQAOAVAHAZQAEhWAUhAIAKgZQglgGgggOIABAJgAQEAIQgXALgZAHIAAAAQAzAhAFAtIAAgCQgBg0ASgkIADgHQABgKAFgJQgOALgUAJg");
	var mask_graphics_38 = new cjs.Graphics().p("APiJeQgegbAAgmQgGgPgBgRQABgYAOgUQgPgaAAgeQAAgXAIgVIAAABQgvAkhCAAQhBAAgvgkQgkgdgIglIgBAAQgdAAgWgVQgKASgMAQQhHBihkAAQg9AAgygkQggABgYgzIgDgJIgCgDQgVgdgPggIgHAQQgQAggWACIgGAHQhQBfhyAAQhyAAhQhfIgEgEIgEAOQgZBPglAAQgkAAgahPQgQg0gGhBQgJAogZAfQgjAtgwAFQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCQiSgBQiSABhoiQQgmg0gYg9QgJgDgJgFQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhDQgphCAAhcQAAhcAphDQArhBA6AAQAfAAAaARQAWgkAgABQANAAAMAFQASgkAYgiQAiguAlgfQgmgfgOgmQgjAFgmABQhlAAhHgkQgagNgQgOIgEAAQglAAgdgOQgKADgMABIgBAAIABAAQAUAKAAAPQAAAOgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgOQAAgKAHgHIgDgDQgSgSAAgaQAAgaASgSQATgTAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAXQA8gWBOAAQBkABBHAiIACABQBAggBTAAQBqAABLA1QBLA2AABLQAAAZgJAXIARgBQArAAAlASQAHgSALgRQAFgYAZgSQAIgGAIgEIAGgEQBThEB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASAOQBSBCAABfQAAAigLAfQBpAFBMBaQANAPALARIAOAGIAQAIQAOgcATgZQBHhiBlAAQBkAABHBiQA5BOAMBnQAIgHAKgGQAPgKARgGIgCgBQg7gegBgpQABgqA7gdQA8geBVAAQBUAAA8AeQA7AdABAqQAAALgFALQALgJAOgEQACgaATgTIAJgHQABgSAQgMQASgNAaAAQAZAAARANQASANAAASQAAANgIAKQAHAMABAPQAVACASAIQAKgTANgQQA2hFBMAAQBMAAA2BFQA2BFAABgQAABig2BFQgnAygyAOQgKAWgfARQgsAahAgBQg/AAgtgZIgEABQgFANgJALQAIAUAAAXQAAAygoAkIgDADIAAALQAAAZgNAUQgEAegaAWQgeAbgqAAQgqAAgfgbgAPcCyQAOASAAAYIgBAMQAKAVAAAYQAAAUgHASQAMgJANgHQACgdAPgXIgGgJQgKgTgBgaQABgbAKgSIACgDQgFgUgBgXQgCArguAhgAmChgQAAAFgCAGIAFADQAgAcABAoQAAAggXAZQAOAVAHAZQAEhWAUhAIAKgZQglgGgggNIABAJgAQEgGQgXAJgZAHIAAABQAzAgAFAtIAAgCQgBgzASgkIADgHQABgLAFgJQgOALgUALg");
	var mask_graphics_39 = new cjs.Graphics().p("APRJtQglgTAAgbQAAgVAYgQIAAgEQgGgPgBgRQABgYAOgUQgPgaAAgeQAAgXAIgVIAAABQgvAkhCAAQhBAAgvgkQgkgdgIglIgBAAQgdAAgWgVQgKASgMAQQhHBihkAAQg9AAgygkQggABgYgzIgDgJIgCgDQgVgdgPggIgHAQQgQAggWACIgGAHQhQBfhyAAQhyAAhQhfIgEgEIgEAOQgZBPglAAQgkAAgahPQgQg0gGhBQgJAogZAfQgjAtgwAFQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCQiSgBQiSABhoiQQgmg0gYg9QgJgDgJgFQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhDQgphCAAhcQAAhcAphDQArhBA6AAQAfAAAaARQAWgkAgABQANAAAMAFQASgkAYgiQAiguAlgfQgmgfgOgmQgjAFgmABQhlAAhHgkQgagNgQgOIgEAAQglAAgdgOQgKADgMABIgBAAIABAAQAUAKAAAPQAAAOgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgOQAAgKAHgHIgDgDQgSgSAAgaQAAgaASgSQATgTAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAXQA8gWBOAAQBkABBHAiIACABQBAggBTAAQBqAABLA1QBLA2AABLQAAAZgJAXIARgBQArAAAlASQAHgSALgRQAFgYAZgSQAIgGAIgEIAGgEQBThEB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASAOQBSBCAABfQAAAigLAfQBpAFBMBaQANAPALARIAOAGIAQAIQAOgcATgZQBHhiBlAAQBkAABHBiQA5BOAMBnQAIgHAKgGQAPgJARgHIgCgBQg7gegBgpQABgqA7gdQA8geBVAAQBUAAA8AeQA7AdABAqQAAALgFALQALgJAOgEQACgaATgTIAJgHQABgSAQgMQASgNAaAAQAZAAARANQASANAAASQAAANgIAKQAHAMABAPQAVACASAIQAKgTANgQQA2hFBMAAQBMAAA2BFQA2BFAABgQAABig2BFQgnAygyAOQgKAWgfARQgsAahAgBQg/AAgtgZIgEABQgFANgJALQAIAUAAAXQAAAygoAkIgDADIAAALQAAAUgIARQAXAQAAAUQAAAbgmATQgmATg1AAQg0AAgngTgAPcCrQAOASAAAYIgBAMQAKAVAAAYQAAAUgHASQAMgJANgHQACgdAPgXIgGgJQgKgTgBgaQABgbAKgSIACgDQgFgUgBgXQgCArguAhgAmChnQAAAFgCAGIAFADQAgAcABAoQAAAggXAZQAOAVAHAZQAEhVAUhBIAKgZQglgGgggNIABAJgAQEgNQgXAKgZAGIAAABQAzAgAFAtIAAgCQgBgzASgkIADgHQABgLAFgJQgOALgUALg");
	var mask_graphics_40 = new cjs.Graphics().p("APTJ7QghgQAAgVQAAgFACgFQgIgKAAgNQAAgVAYgQIAAgEQgGgPgBgRQABgYAOgUQgPgaAAgeQAAgXAIgVIAAABQgvAkhCAAQhBAAgvgkQgkgdgIglIgBAAQgdAAgWgVQgKASgMAQQhHBihkAAQg9AAgygkQggABgYgzIgDgJIgCgDQgVgdgPggIgHAQQgQAggWACIgGAHQhQBfhyAAQhyAAhQhfIgEgEIgEAOQgZBPglAAQgkAAgahPQgQg0gGhBQgJAogZAfQgjAtgwAFQgEAkgmAZQgrAdg8AAIgMAAIgRAZQhnCQiSgBQiSABhoiQQgmg0gYg9QgJgDgJgFQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhDQgphCAAhcQAAhcAphDQArhBA6AAQAfAAAaARQAWgkAgABQANAAAMAFQASgkAYgiQAiguAlgfQgmgfgOgmQgjAFgmABQhlAAhHgkQgagNgQgOIgEAAQglAAgdgOQgKADgMABIgBAAIABAAQAUAKAAAPQAAAOgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgOQAAgKAHgHIgDgDQgSgSAAgaQAAgaASgSQATgTAaAAIAGAAQAFgLAJgJQAVgVAeAAIABAAIABAAQAjgaAzAAQAuAAAiAXQA8gWBOAAQBkABBHAiIACABQBAggBTAAQBqAABLA1QBLA2AABLQAAAZgJAXIARgBQArAAAlASQAHgSALgRQAFgYAZgSQAIgGAIgEIAGgEQBThEB1AAQBFAAA6AYQASAEAPAIQAPAIAHAKIASAOQBSBCAABfQAAAigLAfQBpAFBMBaQANAPALARIAOAGIAQAIQAOgcATgZQBHhiBlAAQBkAABHBiQA5BOAMBnQAIgHAKgFQAPgKARgHIgCgBQg7gegBgpQABgqA7gdQA8geBVAAQBUAAA8AeQA7AdABAqQAAALgFALQALgJAOgEQACgaATgTIAJgHQABgSAQgMQASgNAaAAQAZAAARANQASANAAASQAAANgIAKQAHAMABAPQAVACASAIQAKgTANgQQA2hFBMAAQBMAAA2BFQA2BFAABgQAABig2BFQgnAygyAOQgKAWgfARQgsAahAgBQg/AAgtgZIgEABQgFANgJALQAIAUAAAXQAAAygoAkIgDADIAAALQAAAUgIARQAXAQAAAUQAAAWgZAQQgEASgdAOQggAPgwAAQgvAAghgPgAPcChQAOASAAAYIgBAMQAKAVAAAYQAAAUgHASQAMgJANgHQACgdAPgXIgGgJQgKgTgBgaQABgbAKgSIACgDQgFgUgBgXQgCArguAhgAmChxQAAAFgCAGIAFADQAgAcABAoQAAAggXAZQAOAVAHAZQAEhVAUhBIAKgZQglgGgggNIABAJgAQEgXQgXAKgZAHIAAABQAzAfAFAtIAAgCQgBgzASgkIADgHQABgLAFgJQgOALgUALg");
	var mask_graphics_41 = new cjs.Graphics().p("APuKIQgSgMgFgPIgEgBQghgQAAgVQAAgFACgFQgIgKAAgMQAAgVAYgRIAAgEQgGgOgBgRQABgZAOgUQgPgZAAgfQAAgXAIgUIAAAAQgvAlhCAAQhBAAgvglQgkgcgIgmIgBAAQgdAAgWgUQgKARgMAQQhHBihkAAQg9AAgygjQggAAgYgzIgDgJIgCgDQgVgdgPggIgHAQQgQAggWACIgGAHQhQBghyAAQhyAAhQhgIgEgEIgEAOQgZBPglAAQgkAAgahPQgQgzgGhCQgJAogZAfQgjAtgwAGQgEAjgmAaQgrAdg8AAIgMAAIgRAZQhnCPiSAAQiSAAhoiPQgmg1gYg8QgJgEgJgFQgNgIgFgKIgNABQgjAAgZgQIgCgCIgFAAQg6AAgrhCQgphCAAhdQAAhcAphCQArhCA6AAQAfAAAaARQAWgjAgAAQANAAAMAGQASglAYgiQAiguAlgfQgmgegOgmQgjAFgmAAQhlAAhHgkQgagMgQgPIgEAAQglAAgdgOQgKAEgMAAIgBAAIABAAQAUAKAAAPQAAAOgUAKQgVAKgdAAQgdAAgVgKQgUgKAAgOQAAgJAHgIIgDgCQgSgTAAgaQAAgaASgSQATgTAaAAIAGABQAFgLAJgKQAVgUAeAAIABAAIABgBQAjgaAzAAQAuAAAiAXQA8gVBOAAQBkAABHAjIACABQBAghBTAAQBqAABLA1QBLA2AABLQAAAagJAWIARAAQArAAAlARQAHgSALgQQAFgYAZgTQAIgFAIgEIAGgFQBThDB1AAQBFAAA6AXQASAEAPAIQAPAIAHAKIASAOQBSBDAABeQAAAigLAfQBpAFBMBaQANAPALARIAOAGIAQAIQAOgcATgZQBHhiBlAAQBkAABHBiQA5BOAMBoQAIgHAKgGQAPgKARgHIgCgBQg7gegBgpQABgqA7gdQA8geBVAAQBUAAA8AeQA7AdABAqQAAALgFALQALgJAOgEQACgZATgUIAJgHQABgRAQgNQASgNAaAAQAZAAARANQASANAAATQAAAMgIALQAHAMABAOQAVADASAHQAKgSANgRQA2hFBMAAQBMAAA2BFQA2BFAABhQAABhg2BFQgnAygyAOQgKAWgfARQgsAahAAAQg/AAgtgZIgEAAQgFANgJALQAIAUAAAXQAAAygoAkIgDADIAAAMQAAATgIARQAXAQAAAVQAAAVgZARQgCALgNAKQgCAWgYAQQgaARglAAQgkAAgagRgAPcCSQAOASAAAYIgBANQAKAVAAAYQAAAUgHARQAMgJANgGQACgeAPgXIgGgJQgKgSgBgbQABgaAKgTIACgDQgFgUgBgXQgCAsguAggAmCiAQAAAGgCAFIAFAEQAgAcABAnQAAAhgXAYQAOAWAHAZQAEhWAUhBIAKgZQglgGgggNIABAJgAQEgmQgXALgZAHIAAAAQAzAfAFAtIAAgCQgBgzASgkIADgHQABgKAFgKQgOAMgUAKg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:5.75,y:12.2}).wait(1).to({graphics:mask_graphics_1,x:5.075,y:7.6}).wait(1).to({graphics:mask_graphics_2,x:7.575,y:5.575}).wait(1).to({graphics:mask_graphics_3,x:14.475,y:4.25}).wait(1).to({graphics:mask_graphics_4,x:31.45,y:4.925}).wait(1).to({graphics:mask_graphics_5,x:48.15,y:11.3}).wait(1).to({graphics:mask_graphics_6,x:61.525,y:28.525}).wait(1).to({graphics:mask_graphics_7,x:61.85,y:45.175}).wait(1).to({graphics:mask_graphics_8,x:61.85,y:47.2}).wait(1).to({graphics:mask_graphics_9,x:61.85,y:47.2}).wait(1).to({graphics:mask_graphics_10,x:61.85,y:47.2}).wait(1).to({graphics:mask_graphics_11,x:61.85,y:47.2}).wait(1).to({graphics:mask_graphics_12,x:61.85,y:47.2}).wait(1).to({graphics:mask_graphics_13,x:61.85,y:47.2}).wait(1).to({graphics:mask_graphics_14,x:61.85,y:47.2}).wait(1).to({graphics:mask_graphics_15,x:61.85,y:47.2}).wait(1).to({graphics:mask_graphics_16,x:61.85,y:47.2}).wait(1).to({graphics:mask_graphics_17,x:61.85,y:49.775}).wait(1).to({graphics:mask_graphics_18,x:61.85,y:53.575}).wait(1).to({graphics:mask_graphics_19,x:70.15,y:53.575}).wait(1).to({graphics:mask_graphics_20,x:75.5,y:53.575}).wait(1).to({graphics:mask_graphics_21,x:80.2,y:53.575}).wait(1).to({graphics:mask_graphics_22,x:92.875,y:53.575}).wait(1).to({graphics:mask_graphics_23,x:92.875,y:53.575}).wait(1).to({graphics:mask_graphics_24,x:92.875,y:53.575}).wait(1).to({graphics:mask_graphics_25,x:100.025,y:53.575}).wait(1).to({graphics:mask_graphics_26,x:108.95,y:53.575}).wait(1).to({graphics:mask_graphics_27,x:113.775,y:53.575}).wait(1).to({graphics:mask_graphics_28,x:129.65,y:53.575}).wait(1).to({graphics:mask_graphics_29,x:133.475,y:53.575}).wait(1).to({graphics:mask_graphics_30,x:133.475,y:53.575}).wait(1).to({graphics:mask_graphics_31,x:142.1,y:53.575}).wait(1).to({graphics:mask_graphics_32,x:142.9132,y:53.575}).wait(1).to({graphics:mask_graphics_33,x:160.85,y:53.575}).wait(1).to({graphics:mask_graphics_34,x:160.85,y:53.575}).wait(1).to({graphics:mask_graphics_35,x:160.85,y:53.575}).wait(1).to({graphics:mask_graphics_36,x:160.85,y:53.575}).wait(1).to({graphics:mask_graphics_37,x:160.85,y:54.575}).wait(1).to({graphics:mask_graphics_38,x:160.85,y:56.15}).wait(1).to({graphics:mask_graphics_39,x:160.85,y:56.85}).wait(1).to({graphics:mask_graphics_40,x:160.85,y:57.85}).wait(1).to({graphics:mask_graphics_41,x:160.85,y:59.325}).wait(1).to({graphics:null,x:0,y:0}).wait(819));

	// Capa_1
	this.instance = new lib.DisneyTXT();

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(56).to({_off:true},1).wait(804));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,310,125);


(lib.Símbolo6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_3
	this.instance = new lib.parcheblanco();
	this.instance.setTransform(38,-16);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Símbolo6, new cjs.Rectangle(38,-16,795,381), null);


(lib.Símbolo5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF00").s().p("AAmIVQgzgngmguQhAhMgagmQgthDAFglQAFgigohEIgog9QgZk6Dai9QBsheByggIALBzQAEApAEAgQADAVgKAXQgEALgGAIIACB4IALBNQAJBVgMAwQgMAxhyARQg4AIg3gBIB8AxIBjA1IBIA6IAfBdIAABIIgYAtIgxAqIhpA6QgSgKgagTg");
	this.shape.setTransform(22.2464,33.85);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Símbolo5, new cjs.Rectangle(-3.7,-22.4,52,112.5), null);


(lib.Símbolo4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF00").s().p("AFAHXQhSgUgngBQgqgBgYgjQglg4gwggQhBgsgPgoQgEgNABgKIACgIQACgzBbhYQAagZAagVQAPgFAKgGQARgLgBgJQgVAOgUARQgjALg+ADQhYADgsggQgOgKgHgLIgFgKIgohmIgqhNQhLhrgihFQgKgTglgcQgmgdgDgGQgRgaDeATQDeATCrC3QBWBcApBYIAeBYQAkBjAbAxQAeA2gCBhQgBBYgWAzQgMAdgrAAQgMAAgOgCg");
	this.shape.setTransform(63.9714,80.9899);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Símbolo4, new cjs.Rectangle(21.6,33.7,84.80000000000001,94.60000000000001), null);


(lib.Símbolo3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_3
	this.instance = new lib.Mapadebits17();
	this.instance.setTransform(28,35);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Símbolo3, new cjs.Rectangle(0,0,109,130), null);


(lib.Símbolo2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_3
	this.instance = new lib.Mapadebits19();
	this.instance.setTransform(-5,-25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Símbolo2, new cjs.Rectangle(-5,-25,117,133), null);


(lib.Interpolación18 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZA5QgIgDgJgGIANgZQANANAOAAQAHAAAEgFQACgDAAgEQABgEgEgDQgCgCgMgEIgIgCQgLgEgGgFQgGgHAAgOQAAgRALgLQALgLARAAQATAAARAJIgLAYQgLgHgJAAQgHgBgCAEQgEADAAADQABAEABABQACAEAHABIAKADQAOAFAHAHQAHAHAAANQAAASgLALQgMAMgVAAQgNAAgLgEg");
	this.shape.setTransform(49,-3.85);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgtAsQgSgSgBgaQABgZASgRQASgSAbAAQAcAAASASQASARABAZQgBAagSASQgSARgcAAQgbAAgSgRgAgWgVQgKAJAAANQAAANAKAIQAJAKANAAQAOAAAJgKQAKgJAAgNQAAgMgKgJQgKgKgNAAQgNAAgJAKg");
	this.shape_1.setTransform(36.9,-3.85);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgOA6IAAhaIgZAAIAAgZIBPAAIAAAZIgZAAIAABag");
	this.shape_2.setTransform(25.65,-3.825);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AgaArQgRgSAAgZQAAgYARgRQASgTAaABQAMAAAPAFIAAAkQgLgMgQAAQgMAAgIAIQgKAJAAANQAAAPAJAIQAIAJANAAQAPAAAMgNIAAAkQgRAFgJABQgbAAgSgSg");
	this.shape_3.setTransform(16.4,-3.8);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgnAtQgLgMAAgaIAAhBIAeAAIAABDQAAAMAHAGQAFAGAIAAQAIAAAGgFQAGgGABgPIAAhBIAeAAIAABBQAAAMgCAHQgDALgIAIQgPAPgXAAQgZgBgOgOg");
	this.shape_4.setTransform(4.95,-3.7);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgyA6IAAhzIAoAAQAcAAARAQQAQAPAAAaQAAAZgPAQQgSARgaAAgAgUAhIAGAAQAQAAAJgJQAJgIAAgQQAAgQgJgIQgIgIgPAAIgIAAg");
	this.shape_5.setTransform(-7.175,-3.825);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AgtAsQgSgSgBgaQABgZASgRQASgSAbAAQAcAAASASQATARAAAZQAAAagTASQgSARgcAAQgbAAgSgRgAgXgVQgJAJAAANQAAANAJAIQAKAKANAAQAOAAAJgKQAKgJAAgNQAAgMgKgJQgKgKgNAAQgNAAgKAKg");
	this.shape_6.setTransform(-20.6,-3.85);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AALA6IgcgtIAAAtIgfAAIAAhzIAwAAQARAAALAKQAKAKAAAQQAAAPgKAIQgGAHgKABIAkAwgAgRgFIAGAAQAKAAADgFQAEgEAAgGQAAgGgEgDQgDgFgKAAIgGAAg");
	this.shape_7.setTransform(-32.65,-3.825);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AgsA6IAAhzIAwAAQASAAAMAKQALAKgBASQAAATgKAJQgKALgTAAIgSAAIAAAmgAgNgEIAKAAQAIAAAEgEQAEgDAAgHQAAgHgEgEQgEgEgHAAIgLAAg");
	this.shape_8.setTransform(-43.5,-3.825);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AALA6IgcgtIAAAtIgeAAIAAhzIAvAAQASAAAJAKQALAKgBAQQAAAPgJAIQgGAHgKABIAkAwgAgRgFIAGAAQAKAAADgFQAFgEAAgGQAAgGgFgDQgDgFgKAAIgGAAg");
	this.shape_9.setTransform(-58.1,-3.825);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AggA6IAAhzIBBAAIAAAZIgjAAIAAAUIAhAAIAAAYIghAAIAAAVIAjAAIAAAZg");
	this.shape_10.setTransform(-68.175,-3.825);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFFF").s().p("AgLA6IgxhzIAhAAIAbBGIAchGIAhAAIgyBzg");
	this.shape_11.setTransform(-78.775,-3.825);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	// Capa_2
	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#0E3182").s().p("AuSC0QhkAAAAhkIAAifQAAhkBkAAIclAAQBkAAAABkIAACfQAABkhkAAg");
	this.shape_12.setTransform(-15.475,-3.95);

	this.timeline.addTween(cjs.Tween.get(this.shape_12).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-117,-22,204,36.1);


(lib.Interpolación17 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.LogoENCANTO_solo();
	this.instance.setTransform(-405,-94);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(46));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-405,-94,648,151);


(lib.Interpolación15 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_3
	this.instance = new lib.Mapadebits18();
	this.instance.setTransform(-18,-30);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-18,-30,31,69);


(lib.Interpolación1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ARTWORK
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0E3182").s().p("EAgIAEKQgxg4AAhTQAAhSAxg1QAwg2BKAAQBAgBAyA0IAAgpIBUAAIAAFqIhUAAIAAgmQg0Axg8gBQhLABgxg3gEAhJAAtQgcAhAAAxQAAA1AcAgQAcAhAsABQAuAAAdghQAdghAAgzQAAg0gdggQgcghguAAQgrAAgeAhgAW4EbQgZgVgMgeQgKgZAAgyIAAjRIBUAAIAADPQAABbBHAAQBIAAAAhbIAAjPIBTAAIAADRQAAAsgKAfQgLAegaAVQgqAmhCgBQhBABgrgmgAREEKQg5g2AAhTQAAhQA6g3QA5g4BUAAQA2AAAwAZIAABvQgegkgWgNQgWgNgfAAQgwAAgeAiQggAgAAAzQAAAzAeAgQAfAiAvAAQAegBAYgNQAWgMAfglIAABvQg0AbgzgBQhVABg4g3gAEZEMQgxg1AAhWQAAhWAvg1QAwg0BQAAQBQgBAvAzQAuAzAABZIAAAUIkFAAQAEAtAZAaQAbAbAoAAQAfgBAUgPQAVgPAZgoIBHAoQgQAcgSAUQgUAVgUALQgVANgYAHQgYAFgcAAQhSABgxg1gAF8ARQgMAEgMAJQgLAIgIANQgIAMgEAQICpAAQgShDhDAAQgQAAgNAFgAsnEKQgxg4AAhTQAAhSAxg1QAxg2BKAAQA/gBAzA0IAAgpIBUAAIAAFqIhUAAIAAgmQg0Axg8gBQhLABgyg3gArlAtQgdAhAAAxQAAA0AcAhQAdAhAsABQAuAAAdghQAdghAAgzQAAgzgdghQgdghguAAQgrAAgdAhgA8MEMQgyg1AAhWQAAhWAwg1QAwg0BQAAQBQgBAvAzQAuAzAABZIAAAUIkFAAQADAsAaAbQAaAbAoAAQAggBAUgPQAVgPAZgoIBHAoQgRAdgSATQgSAUgVAMQgVANgYAHQgYAFgdAAQhRABgxg1gA6pARQgOAEgKAJQgMAJgHAMQgIAMgEAQICpAAQgShDhDAAQgQAAgNAFgAcqE2IAAp2IBUAAIAAJ2gANeE2IAAlqIBUAAIAAFqgAKgE2IAAp2IBUAAIAAJ2gAiAE2IAApAIBjAAQBGAAAmAKQAmALAcAcQAxAwAABKQAABQg1AtQg1AuhZAAIgoAAIAADqgAgpgEIAgAAQB3AAAAhcQAAhZh6AAIgdAAgAyJE2IAApAIBXAAIAAHuICpAAIAABSgEglHAE2IAApAIB5AAQBWAAAzASQA2ARAsAoQBZBRAACEQAACEhdBTQgwAqgxAPQgxAQhXAAgEgjwADkIAnAAQA5AAAogMQAngOAfgcQBBg6AAheQAAhdhAg8Qg5g0hvgBIgnAAgANhiJIBfiIIBMApIh8B7g");
	this.shape.setTransform(-4.4,4.8,0.545,0.545,0,0,0,-0.5,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-133.6,-12.4,259,34.9);


(lib.btnclose = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#ADB7D2").s().p("AAjBIIgjgrIgkArQgKAMgMAAQgJAAgHgGQgHgFAAgJQAAgIAHgIIAtgwIgpgsQgIgJAAgJQAAgKAHgFQAGgGAKAAQANAAAKAMIAgAoIAigoQAKgMAMAAQAKAAAGAFQAHAGAAAJQAAAIgHAIIgrAuIAsAuQAJAJAAAJQAAAJgHAGQgHAGgKAAQgNAAgKgMg");
	this.shape.setTransform(18.825,24.025);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("Ai0C1QhLhLAAhqQAAhpBLhLQBLhLBpAAQBqAABLBLQBLBLAABpQAABqhLBLQhLBLhqAAQhpAAhLhLg");
	this.shape_1.setTransform(18.652,24.6689,0.7285,0.7285);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,3.8,37.3,39.5);


(lib.btn_main = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00FF33").s().p("EhVbAu0QhXAAg9g+Qg+g9AAhYMAAAhXCQAAhWA+g+QA9g9BXgBMCq3AAAQBXABA9A9QA+A+AABWMAAABXCQAABYg+A9Qg9A+hXAAg");
	this.shape.setTransform(567.775,299.55);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1135.6,599.1);


(lib.ala33 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_3
	this.instance = new lib.Mapadebits19();
	this.instance.setTransform(-5,-24);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ala33, new cjs.Rectangle(-5,-24,117,132), null);


(lib.ALA22 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_3
	this.instance = new lib.Mapadebits19();
	this.instance.setTransform(-5,-24);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ALA22, new cjs.Rectangle(-5,-24,117,132), null);


(lib.ALA3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_4
	this.instance = new lib.Mapadebits17();
	this.instance.setTransform(26,35);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ALA3, new cjs.Rectangle(2,0,105,130), null);


(lib.ALA2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_3
	this.instance = new lib.Mapadebits17();
	this.instance.setTransform(28,35);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ALA2, new cjs.Rectangle(0,0,109,130), null);


(lib.Símbolo9copia = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Símbolo10copia();
	this.instance.setTransform(11.7,10.95,1,1,0,0,0,10.8,10.8);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[11.6,10.9,12.8,11,13.7,11.9,14.7,12.9,14.7,14.2,14.7,15.6,13.7,16.7,12.6,17.7,11.1,17.7,9.9,17.7,8.9,16.7,7.9,15.6,7.9,14.2,7.9,12.9,8.9,11.9,9.6,11,10.6,10.9]}},47).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.9,0.1,28.299999999999997,28.299999999999997);


(lib.Símbolo9 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Símbolo10();
	this.instance.setTransform(11.05,10.8,1,1,0,0,0,10.8,10.8);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[11.1,10.9,9.8,10.9,8.9,11.9,7.9,12.9,7.9,14.2,7.9,15.6,8.9,16.7,9.9,17.7,11.2,17.7,12.7,17.7,13.7,16.7,14.7,15.6,14.7,14.2,14.7,12.9,13.7,11.9,12.7,10.9,11.4,10.9]}},47).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.9,0,28.299999999999997,28.4);


(lib.Símbolo1copiacopia2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Interpolación15("synched",0);
	this.instance.setTransform(100.15,84,1,1,15.4579,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({rotation:0},24).to({rotation:19.6922,y:84.05},24).to({rotation:0,y:84},22).to({startPosition:0},26).to({rotation:15.4579},23).wait(1));

	// ala2_png
	this.instance_1 = new lib.ala33();
	this.instance_1.setTransform(100.95,76.05,0.5,1,0,0,0,-1,50.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({regX:-1.1,scaleX:1},24,cjs.Ease.cubicInOut).to({regX:-1,scaleX:0.4},24,cjs.Ease.cubicInOut).to({regX:-1.1,scaleX:1},22,cjs.Ease.cubicInOut).to({scaleX:0.86},12,cjs.Ease.cubicInOut).to({scaleX:1},14,cjs.Ease.cubicInOut).to({regX:-1,scaleX:0.5},23,cjs.Ease.cubicInOut).wait(1));

	// ala1_png
	this.instance_2 = new lib.ALA3();
	this.instance_2.setTransform(99.85,77.75,0.5,1,0,0,0,97.5,76.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({scaleX:1,x:99.9},24,cjs.Ease.cubicInOut).to({scaleX:0.4,x:99.85},24,cjs.Ease.cubicInOut).to({scaleX:1,x:99.9},22,cjs.Ease.cubicInOut).to({scaleX:0.86},12,cjs.Ease.cubicInOut).to({scaleX:1},14,cjs.Ease.cubicInOut).to({scaleX:0.5,x:99.85},23,cjs.Ease.cubicInOut).wait(1));

	// Capa_5
	this.instance_3 = new lib.Símbolo5();
	this.instance_3.setTransform(101.4,75.95,0.5,1,0,0,0,-3.1,47.6);
	this.instance_3.alpha = 0.5;
	this.instance_3.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_3.cache(-6,-24,56,117);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({scaleX:1},24,cjs.Ease.cubicInOut).to({regX:-3,scaleX:0.4},24,cjs.Ease.cubicInOut).to({regX:-3.1,scaleX:1},22,cjs.Ease.cubicInOut).to({scaleX:0.86},12,cjs.Ease.cubicInOut).to({scaleX:1},14,cjs.Ease.cubicInOut).to({scaleX:0.5},23,cjs.Ease.cubicInOut).wait(1));

	// Capa_4
	this.instance_4 = new lib.Símbolo4();
	this.instance_4.setTransform(99.35,77.8,0.5,1,0,0,0,94.7,73.5);
	this.instance_4.alpha = 0.5;
	this.instance_4.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_4.cache(20,32,89,99);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({scaleX:1,x:99.4},24,cjs.Ease.cubicInOut).to({regX:94.8,scaleX:0.4,x:99.35},24,cjs.Ease.cubicInOut).to({regX:94.7,scaleX:1,x:99.4},22,cjs.Ease.cubicInOut).to({scaleX:0.86,x:99.35},12,cjs.Ease.cubicInOut).to({scaleX:1,x:99.4},14,cjs.Ease.cubicInOut).to({scaleX:0.5,x:99.35},23,cjs.Ease.cubicInOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.7,-22,190.5,190);


(lib.Símbolo1copiacopia = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Interpolación15("synched",0);
	this.instance.setTransform(100.05,83.9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(61).to({startPosition:0},0).to({regX:0.1,regY:0.1,rotation:12.0462,x:100.15,y:84},24).to({regX:0,regY:0,rotation:0,x:100.05,y:83.9},22).wait(13));

	// ala2_png
	this.instance_1 = new lib.ALA22();
	this.instance_1.setTransform(105.3,73.45,0.88,1,0,0,0,4,48.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1},14,cjs.Ease.quadInOut).to({scaleX:0.85},23,cjs.Ease.quadInOut).to({scaleX:1},24,cjs.Ease.quadInOut).to({regX:4.2,scaleX:0.5,x:105.35},24,cjs.Ease.quadInOut).to({regX:4,scaleX:1},22,cjs.Ease.quadInOut).to({scaleX:0.88,x:105.3},12,cjs.Ease.quadInOut).wait(1));

	// ala1_png
	this.instance_2 = new lib.ALA2();
	this.instance_2.setTransform(99.9,80,0.8796,1,0,0,0,99.6,78.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:99.5,regY:78.4,scaleX:0.9996,scaleY:0.9996,rotation:-0.0009,y:80.05},14,cjs.Ease.quadInOut).to({scaleX:0.7997,scaleY:0.9992,x:99.85},23,cjs.Ease.quadInOut).to({scaleX:0.9996,scaleY:0.9996,x:99.9},24,cjs.Ease.quadInOut).to({scaleX:0.4998,scaleY:0.9987,rotation:0,x:99.95},24,cjs.Ease.quadInOut).to({scaleX:0.9996,scaleY:0.9996,rotation:-0.0009,x:99.9},22,cjs.Ease.quadInOut).to({regY:78.3,scaleX:0.8796,scaleY:0.9992,x:99.85,y:80},12,cjs.Ease.quadInOut).wait(1));

	// Capa_5
	this.instance_3 = new lib.Símbolo5();
	this.instance_3.setTransform(101.3,75.15,0.8795,1,0,0,0,-0.1,51.1);
	this.instance_3.alpha = 0.5;
	this.instance_3.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_3.cache(-6,-24,56,117);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regX:0,scaleX:1,x:101.35},14,cjs.Ease.quadInOut).to({regX:0.1,scaleX:0.85,x:101.4},23,cjs.Ease.quadInOut).to({regX:0,scaleX:1,x:101.35},24,cjs.Ease.quadInOut).to({regX:0.1,scaleX:0.5},24,cjs.Ease.quadInOut).to({scaleX:0.88,x:101.4},22,cjs.Ease.quadInOut).wait(13));

	// Capa_4
	this.instance_4 = new lib.Símbolo4();
	this.instance_4.setTransform(97.45,78.35,0.88,1,0,0,0,92.5,73.5);
	this.instance_4.alpha = 0.5;
	this.instance_4.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_4.cache(20,32,89,99);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:92.6,scaleX:1,x:97.5},14,cjs.Ease.quadInOut).to({regX:92.7,scaleX:0.8,x:97.55},23,cjs.Ease.quadInOut).to({regX:92.6,scaleX:1,x:97.5},24,cjs.Ease.quadInOut).to({scaleX:0.5},24,cjs.Ease.quadInOut).to({scaleX:1},22,cjs.Ease.quadInOut).to({regX:92.5,scaleX:0.88,x:97.45},12,cjs.Ease.quadInOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.5,-26.3,187.1,195.9);


(lib.Símbolo1copia4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Interpolación15("synched",0);
	this.instance.setTransform(100.15,84,1,1,-7.4135,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({startPosition:0},1).to({startPosition:0},1).to({startPosition:0},1).wait(1));

	// ala2_png
	this.instance_1 = new lib.Símbolo2();
	this.instance_1.setTransform(105.35,85.8,0.4991,1.0248,0,-3.9059,-12.0737,5,57.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1,scaleY:1,rotation:-7.4135,skewX:0,skewY:0,x:107.05,y:83.05},1).to({scaleX:0.4991,scaleY:1.0248,rotation:0,skewX:-3.9059,skewY:-12.0737,x:105.35,y:85.8},1).to({regX:5.7,regY:57.2,scaleX:0.1538,scaleY:0.9917,skewX:-0.6286,skewY:-57.0352,x:103.55,y:83.05},1).wait(1));

	// ala1_png
	this.instance_2 = new lib.Símbolo3();
	this.instance_2.setTransform(95.5,83.85,0.5441,1.0072,0,-4.0199,-23.0935,91,83);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({scaleX:1,scaleY:1,rotation:-7.4135,skewX:0,skewY:0,x:93.2,y:84.85},1).to({scaleX:0.5441,scaleY:1.0072,rotation:0,skewX:-4.0199,skewY:-23.0935,x:95.5,y:83.85},1).to({scaleX:0.1607,scaleY:0.9917,skewX:-0.7203,skewY:-53.3999,x:97.65,y:84.85},1).wait(1));

	// Capa_5
	this.instance_3 = new lib.Símbolo5();
	this.instance_3.setTransform(105.15,87.25,0.4991,1.0248,0,-3.9059,-12.0737,2.2,56.3);
	this.instance_3.alpha = 0.5;
	this.instance_3.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_3.cache(-6,-24,56,117);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regX:2,regY:56.2,scaleX:1,scaleY:1,rotation:-7.4135,skewX:0,skewY:0,x:106.55,y:84.6},1).to({regX:2.2,regY:56.3,scaleX:0.4991,scaleY:1.0248,rotation:0,skewX:-3.9059,skewY:-12.0737,x:105.15,y:87.25},1).to({regY:56.2,scaleX:0.1538,scaleY:0.9917,skewX:-0.6286,skewY:-57.0352,x:103.5,y:84.55},1).wait(1));

	// Capa_4
	this.instance_4 = new lib.Símbolo4();
	this.instance_4.setTransform(95.5,83.75,0.5441,1.0072,0,-4.0199,-23.0935,88.5,80.5);
	this.instance_4.alpha = 0.5;
	this.instance_4.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_4.cache(20,32,89,99);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({scaleX:1,scaleY:1,rotation:-7.4135,skewX:0,skewY:0,x:93.15,y:84.85},1).to({scaleX:0.5441,scaleY:1.0072,rotation:0,skewX:-4.0199,skewY:-23.0935,x:95.5,y:83.75},1).to({regX:88.7,scaleX:0.1607,scaleY:0.9917,skewX:-0.7203,skewY:-53.3999,x:97.65,y:84.8},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-7.3,-27.3,200,210.3);


(lib.Símbolo1copia3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Interpolación15("synched",0);
	this.instance.setTransform(100.15,84.05,1,1,19.2304,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({rotation:0,y:84},1).to({startPosition:0},1).to({startPosition:0},1).wait(1));

	// ala2_png
	this.instance_1 = new lib.Símbolo2();
	this.instance_1.setTransform(100.4,73.95,0.2,1,0,0,0,-1.5,48);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({regX:-1.6,scaleX:0.5},1).to({regX:-1.7,scaleX:1,x:100.35},1).to({regX:-1.6,scaleX:0.5,x:100.4},1).wait(1));

	// ala1_png
	this.instance_2 = new lib.Símbolo3();
	this.instance_2.setTransform(101.15,78.75,0.2,1,0,0,0,99.2,76.9);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:99,scaleX:0.5},1).to({regX:98.9,scaleX:1},1).to({regX:99,scaleX:0.5},1).wait(1));

	// Capa_5
	this.instance_3 = new lib.Símbolo5();
	this.instance_3.setTransform(103.5,84.65,0.2,1,0,0,0,3.8,56.6);
	this.instance_3.alpha = 0.5;
	this.instance_3.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_3.cache(-6,-24,56,117);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regX:2.2,regY:56.4,scaleX:0.4997,scaleY:0.9998,skewX:-3.7902,skewY:-12.0247,x:105.2,y:87.3},1).to({regX:2,regY:56.2,scaleX:1,scaleY:1,rotation:-7.4135,skewX:0,skewY:0,x:106.55,y:84.6},1).to({regX:2.2,regY:56.4,scaleX:0.4997,scaleY:0.9998,rotation:0,skewX:-3.7902,skewY:-12.0247,x:105.2,y:87.3},1).wait(1));

	// Capa_4
	this.instance_4 = new lib.Símbolo4();
	this.instance_4.setTransform(97.65,84.9,0.2,0.9917,0,0,0,89,80.7);
	this.instance_4.alpha = 0.5;
	this.instance_4.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_4.cache(20,32,89,99);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:88.6,scaleX:0.5,scaleY:1,x:95.5,y:83.9},1).to({regX:88.5,regY:80.5,scaleX:1,x:93.2,y:84.8},1).to({regX:88.6,regY:80.7,scaleX:0.5,scaleY:1.0071,x:95.5,y:83.9},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.7,-27.3,194.39999999999998,195.60000000000002);


(lib.Símbolo1copia2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Interpolación15("synched",0);
	this.instance.setTransform(100.15,84.05,1,1,11.5414,0,0,0.1,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regY:0.1,rotation:18.0484},1).to({rotation:10.0585,y:84},1).to({rotation:0.7921,x:100.2},1).wait(1));

	// ala2_png
	this.instance_1 = new lib.Símbolo2();
	this.instance_1.setTransform(105.3,85.8,0.499,1.0248,0,0,0,5.1,57.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({regX:6.2,regY:57.4,scaleX:0.4,scaleY:0.9917,x:103.55,y:83.1},1).to({regX:5.2,scaleX:0.499,scaleY:1.0248,x:105.3,y:85.9},1).to({regX:5,regY:57.1,scaleX:1,scaleY:1,x:107.05,y:83.05},1).wait(1));

	// ala1_png
	this.instance_2 = new lib.Símbolo3();
	this.instance_2.setTransform(95.45,83.85,0.5441,1.0071,0,0,0,91,83.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:91.2,scaleX:0.4,scaleY:0.9917,x:97.65,y:84.85},1).to({regX:91,scaleX:0.5441,scaleY:1.0071,x:95.45,y:83.85},1).to({regX:90.9,regY:83,scaleX:1,scaleY:1,x:93.15,y:84.85},1).wait(1));

	// Capa_5
	this.instance_3 = new lib.Símbolo5();
	this.instance_3.setTransform(105.15,87.35,0.499,1.0248,0,0,0,2.4,56.4);
	this.instance_3.alpha = 0.5;
	this.instance_3.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_3.cache(-6,-24,56,117);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regX:2.6,scaleX:0.4,scaleY:0.9917,x:103.5,y:84.6},1).to({regX:2.4,scaleX:0.499,scaleY:1.0248,x:105.15,y:87.35},1).to({regX:2.1,regY:56.2,scaleX:1,scaleY:1,x:106.6,y:84.55},1).wait(1));

	// Capa_4
	this.instance_4 = new lib.Símbolo4();
	this.instance_4.setTransform(95.5,83.9,0.5441,1.0071,0,0,0,88.6,80.7);
	this.instance_4.alpha = 0.5;
	this.instance_4.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_4.cache(20,32,89,99);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:89,scaleX:0.4,scaleY:0.9917,x:97.65,y:84.9},1).to({regX:88.6,scaleX:0.5441,scaleY:1.0071,x:95.5,y:83.9},1).to({regX:88.5,regY:80.5,scaleX:1,scaleY:1,x:93.2,y:84.8},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.7,-22,190.5,190.3);


(lib.Símbolo1copia = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Interpolación15("synched",0);
	this.instance.setTransform(100.05,83.95,1,1,14.5269);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:0.1,regY:0.1,rotation:0,x:100.15,y:84},22,cjs.Ease.cubicIn).to({regX:0,regY:0,x:100.05,y:83.9},26,cjs.Ease.cubicIn).to({regX:0.1,regY:0.1,rotation:17.452,x:100.15,y:84},23).to({regX:0,regY:0,rotation:0,x:100.05,y:83.9},24,cjs.Ease.cubicIn).to({rotation:14.5269,y:83.95},24).wait(1));

	// ala2_png
	this.instance_1 = new lib.Símbolo2();
	this.instance_1.setTransform(98.75,77.05,0.5,1,0,0,0,-2.4,50.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1},22,cjs.Ease.cubicInOut).to({regX:-2.5,scaleX:0.7996,scaleY:0.9996,x:98.7},12,cjs.Ease.cubicInOut).to({scaleX:1,scaleY:1,x:98.75},14,cjs.Ease.cubicInOut).to({regX:-2.4,scaleX:0.3998,scaleY:0.9995},23,cjs.Ease.cubicInOut).to({regX:-2.5,scaleX:1,scaleY:1},24,cjs.Ease.cubicInOut).to({regX:-2.4,scaleX:0.5},24,cjs.Ease.cubicInOut).wait(1));

	// ala1_png
	this.instance_2 = new lib.Símbolo3();
	this.instance_2.setTransform(100.1,84,0.5,0.9996,0,0,0,98.1,83.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({regX:68.5,regY:82.5,scaleX:0.5074,x:85.05,y:83.35},0).wait(1).to({scaleX:0.516,x:84.8},0).wait(1).to({scaleX:0.5259,x:84.5},0).wait(1).to({scaleX:0.537,x:84.2},0).wait(1).to({scaleX:0.5493,x:83.85},0).wait(1).to({scaleX:0.5631,x:83.4},0).wait(1).to({scaleX:0.5781,x:82.95},0).wait(1).to({scaleX:0.5946,scaleY:0.9997,x:82.5},0).wait(1).to({scaleX:0.6125,x:81.95},0).wait(1).to({scaleX:0.632,x:81.4},0).wait(1).to({scaleX:0.6529,x:80.7},0).wait(1).to({scaleX:0.6755,x:80.05,y:83.4},0).wait(1).to({scaleX:0.6996,x:79.35},0).wait(1).to({scaleX:0.7255,scaleY:0.9998,x:78.6},0).wait(1).to({scaleX:0.7531,x:77.8},0).wait(1).to({scaleX:0.7825,x:76.9},0).wait(1).to({scaleX:0.8137,x:76},0).wait(1).to({scaleX:0.8468,scaleY:0.9999,x:75},0).wait(1).to({scaleX:0.882,x:73.95},0).wait(1).to({scaleX:0.9192,x:72.85},0).wait(1).to({scaleX:0.9585,scaleY:1,x:71.7},0).wait(1).to({regX:97.9,regY:83,scaleX:1,x:100.1,y:83.95},0).wait(1).to({regX:68.5,regY:82.5,scaleX:0.9965,x:70.75,y:83.45},0).wait(1).to({scaleX:0.992,x:70.9},0).wait(1).to({scaleX:0.9865,scaleY:0.9999,x:71.05},0).wait(1).to({scaleX:0.9799,x:71.25},0).wait(1).to({scaleX:0.9721,x:71.5},0).wait(1).to({scaleX:0.9632,x:71.8},0).wait(1).to({scaleX:0.9529,scaleY:0.9998,x:72.05},0).wait(1).to({scaleX:0.9413,x:72.4},0).wait(1).to({scaleX:0.9283,scaleY:0.9997,x:72.8},0).wait(1).to({scaleX:0.9137,x:73.25,y:83.4},0).wait(1).to({scaleX:0.8975,scaleY:0.9996,x:73.7},0).wait(1).to({regX:98,regY:83,scaleX:0.8796,x:100.15,y:83.95},0).wait(1).to({regX:68.5,regY:82.5,scaleX:0.8825,x:74.1,y:83.4},0).wait(1).to({scaleX:0.8862,x:74},0).wait(1).to({scaleX:0.8906,x:73.85},0).wait(1).to({scaleX:0.8958,x:73.7},0).wait(1).to({scaleX:0.9018,x:73.5},0).wait(1).to({scaleX:0.9086,scaleY:0.9997,x:73.35},0).wait(1).to({scaleX:0.9164,x:73.05},0).wait(1).to({scaleX:0.9251,x:72.8,y:83.45},0).wait(1).to({scaleX:0.9348,scaleY:0.9998,x:72.55},0).wait(1).to({scaleX:0.9455,x:72.2},0).wait(1).to({scaleX:0.9574,x:71.9},0).wait(1).to({scaleX:0.9703,scaleY:0.9999,x:71.5},0).wait(1).to({scaleX:0.9845,x:71.1},0).wait(1).to({regX:97.9,regY:83,scaleX:1,scaleY:1,x:100.1,y:83.95},0).wait(1).to({regX:68.5,regY:82.5,scaleX:0.9915,x:70.9,y:83.45},0).wait(1).to({scaleX:0.9817,x:71.2},0).wait(1).to({scaleX:0.9706,x:71.55},0).wait(1).to({scaleX:0.958,x:71.9},0).wait(1).to({scaleX:0.9441,scaleY:0.9999,x:72.3},0).wait(1).to({scaleX:0.9287,x:72.75},0).wait(1).to({scaleX:0.9119,x:73.25},0).wait(1).to({scaleX:0.8935,x:73.8},0).wait(1).to({scaleX:0.8735,x:74.4},0).wait(1).to({scaleX:0.8519,x:75},0).wait(1).to({scaleX:0.8287,x:75.7},0).wait(1).to({scaleX:0.8037,scaleY:0.9998,x:76.45},0).wait(1).to({scaleX:0.777,x:77.2},0).wait(1).to({scaleX:0.7484,x:78.05},0).wait(1).to({scaleX:0.718,x:79},0).wait(1).to({scaleX:0.6857,x:79.9},0).wait(1).to({scaleX:0.6514,scaleY:0.9997,x:80.9},0).wait(1).to({scaleX:0.615,x:81.95,y:83.4},0).wait(1).to({scaleX:0.5765,x:83.15},0).wait(1).to({scaleX:0.5358,scaleY:0.9996,x:84.3},0).wait(1).to({scaleX:0.4928,x:85.6},0).wait(1).to({scaleX:0.4475,x:86.9},0).wait(1).to({regX:98,regY:83,scaleX:0.3998,scaleY:0.9995,x:100.1,y:83.95},0).to({regX:98.2,scaleX:1,scaleY:1,x:100.15,y:84.05},24,cjs.Ease.cubicInOut).wait(1).to({regX:68.5,regY:82.5,scaleX:0.9932,x:70.65,y:83.55},0).wait(1).to({scaleX:0.9855,x:70.85},0).wait(1).to({scaleX:0.9767,x:71.1},0).wait(1).to({scaleX:0.9669,x:71.45},0).wait(1).to({scaleX:0.956,scaleY:0.9999,x:71.75},0).wait(1).to({scaleX:0.9439,x:72.1},0).wait(1).to({scaleX:0.9308,x:72.45},0).wait(1).to({scaleX:0.9165,x:72.9},0).wait(1).to({scaleX:0.901,x:73.35},0).wait(1).to({scaleX:0.8843,x:73.85},0).wait(1).to({scaleX:0.8663,x:74.4},0).wait(1).to({scaleX:0.847,x:74.95},0).wait(1).to({scaleX:0.8264,scaleY:0.9998,x:75.55},0).wait(1).to({scaleX:0.8045,x:76.2},0).wait(1).to({scaleX:0.7811,x:76.9},0).wait(1).to({scaleX:0.7563,x:77.65},0).wait(1).to({scaleX:0.73,x:78.45},0).wait(1).to({scaleX:0.7021,scaleY:0.9997,x:79.25},0).wait(1).to({scaleX:0.6727,x:80.15},0).wait(1).to({scaleX:0.6416,x:81.05,y:83.5},0).wait(1).to({scaleX:0.6089,x:82},0).wait(1).to({scaleX:0.5744,scaleY:0.9996,x:83.05},0).wait(1).to({scaleX:0.5381,x:84.1},0).wait(1).to({regX:98.1,regY:83.1,scaleX:0.5,x:100.1,y:84},0).wait(1));

	// Capa_5
	this.instance_3 = new lib.Símbolo5();
	this.instance_3.setTransform(106.6,84.55,0.5,1,0,0,0,2.1,56.2);
	this.instance_3.alpha = 0.5;
	this.instance_3.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_3.cache(-6,-24,56,117);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({scaleX:1},22,cjs.Ease.cubicInOut).to({scaleX:0.88},12,cjs.Ease.cubicInOut).to({scaleX:1},14,cjs.Ease.cubicInOut).to({regX:2.2,scaleX:0.4},23,cjs.Ease.cubicInOut).to({regX:2.1,scaleX:1},24,cjs.Ease.cubicInOut).to({scaleX:0.5},24,cjs.Ease.cubicInOut).wait(1));

	// Capa_4
	this.instance_4 = new lib.Símbolo4();
	this.instance_4.setTransform(101.3,81.25,0.5,1,0,0,0,97.1,78.1);
	this.instance_4.alpha = 0.5;
	this.instance_4.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_4.cache(20,32,89,99);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:97,regY:78,scaleX:1},22,cjs.Ease.cubicInOut).to({scaleX:0.88,x:101.25},12,cjs.Ease.cubicInOut).to({scaleX:1,x:101.3},14,cjs.Ease.cubicInOut).to({scaleX:0.4},23,cjs.Ease.cubicInOut).to({scaleX:1},24,cjs.Ease.cubicInOut).to({regX:97.1,regY:78.1,scaleX:0.5},24,cjs.Ease.cubicInOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.1,-22,190.9,190);


(lib.Símbolo1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Interpolación15("synched",0);
	this.instance.setTransform(100.15,84,1,1,-7.4135,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({rotation:7.5855,x:100.2,y:83.95},1).to({rotation:22.5851,x:100.15,y:84},1).to({rotation:7.5855,x:100.2,y:83.95},1).wait(1));

	// ala2_png
	this.instance_1 = new lib.Símbolo2();
	this.instance_1.setTransform(107.05,83.05,1,1,-7.4135,0,0,5,57.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:0.4991,scaleY:1.0248,rotation:0,skewX:-3.9059,skewY:-12.0737,x:105.35,y:85.8},1).to({regX:5.7,regY:57.2,scaleX:0.1538,scaleY:0.9917,skewX:-0.6286,skewY:-57.0352,x:103.55,y:83.05},1).to({regX:5,regY:57.1,scaleX:0.4991,scaleY:1.0248,skewX:-3.9059,skewY:-12.0737,x:105.35,y:85.8},1).wait(1));

	// ala1_png
	this.instance_2 = new lib.Símbolo3();
	this.instance_2.setTransform(93.2,84.85,1,1,-7.4135,0,0,91,83);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({scaleX:0.5441,scaleY:1.0072,rotation:0,skewX:-4.0199,skewY:-23.0935,x:95.5,y:83.85},1).to({scaleX:0.1607,scaleY:0.9917,skewX:-0.7203,skewY:-53.3999,x:97.65,y:84.85},1).to({scaleX:0.5441,scaleY:1.0072,skewX:-4.0199,skewY:-23.0935,x:95.5,y:83.85},1).wait(1));

	// Capa_5
	this.instance_3 = new lib.Símbolo5();
	this.instance_3.setTransform(106.55,84.6,1,1,-7.4135,0,0,2,56.2);
	this.instance_3.alpha = 0.5;
	this.instance_3.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_3.cache(-6,-24,56,117);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regX:2.2,regY:56.3,scaleX:0.4991,scaleY:1.0248,rotation:0,skewX:-3.9059,skewY:-12.0737,x:105.15,y:87.25},1).to({regY:56.2,scaleX:0.1538,scaleY:0.9917,skewX:-0.6286,skewY:-57.0352,x:103.5,y:84.55},1).to({regY:56.3,scaleX:0.4991,scaleY:1.0248,skewX:-3.9059,skewY:-12.0737,x:105.15,y:87.25},1).wait(1));

	// Capa_4
	this.instance_4 = new lib.Símbolo4();
	this.instance_4.setTransform(93.15,84.85,1,1,-7.4135,0,0,88.5,80.5);
	this.instance_4.alpha = 0.5;
	this.instance_4.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_4.cache(20,32,89,99);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({scaleX:0.5441,scaleY:1.0072,rotation:0,skewX:-4.0199,skewY:-23.0935,x:95.5,y:83.75},1).to({regX:88.7,scaleX:0.1607,scaleY:0.9917,skewX:-0.7203,skewY:-53.3999,x:97.65,y:84.8},1).to({regX:88.5,scaleX:0.5441,scaleY:1.0072,skewX:-4.0199,skewY:-23.0935,x:95.5,y:83.75},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-7.3,-27.3,200,210.3);


(lib.DESCA11 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Interpolación15("synched",0);
	this.instance.setTransform(100.15,84,1,1,-7.4135,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({startPosition:0},1).to({startPosition:0},1).to({startPosition:0},1).wait(1));

	// ala2_png
	this.instance_1 = new lib.ALA22();
	this.instance_1.setTransform(105.35,85.8,0.4991,1.0248,0,-3.9059,-12.0737,5,57.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({regX:5.7,regY:57.2,scaleX:0.1538,scaleY:0.9917,skewX:-0.6286,skewY:-57.0352,x:103.55,y:83.05},1).to({regX:5,regY:57.1,scaleX:0.4991,scaleY:1.0248,skewX:-3.9059,skewY:-12.0737,x:105.35,y:85.8},1).to({scaleX:1,scaleY:1,rotation:-7.4135,skewX:0,skewY:0,x:107.05,y:83.05},1).wait(1));

	// ala1_png
	this.instance_2 = new lib.ALA2();
	this.instance_2.setTransform(95.5,83.85,0.5441,1.0072,0,-4.0199,-23.0935,91,83);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({scaleX:0.1607,scaleY:0.9917,skewX:-0.7203,skewY:-53.3999,x:97.65,y:84.85},1).to({scaleX:0.5441,scaleY:1.0072,skewX:-4.0199,skewY:-23.0935,x:95.5,y:83.85},1).to({scaleX:1,scaleY:1,rotation:-7.4135,skewX:0,skewY:0,x:93.2,y:84.85},1).wait(1));

	// Capa_5
	this.instance_3 = new lib.Símbolo5();
	this.instance_3.setTransform(105.15,87.25,0.4991,1.0248,0,-3.9059,-12.0737,2.2,56.3);
	this.instance_3.alpha = 0.5;
	this.instance_3.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_3.cache(-6,-24,56,117);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regY:56.2,scaleX:0.1538,scaleY:0.9917,skewX:-0.6286,skewY:-57.0352,x:103.5,y:84.55},1).to({regY:56.3,scaleX:0.4991,scaleY:1.0248,skewX:-3.9059,skewY:-12.0737,x:105.15,y:87.25},1).to({regX:2,regY:56.2,scaleX:1,scaleY:1,rotation:-7.4135,skewX:0,skewY:0,x:106.55,y:84.6},1).wait(1));

	// Capa_4
	this.instance_4 = new lib.Símbolo4();
	this.instance_4.setTransform(95.5,83.75,0.5441,1.0072,0,-4.0199,-23.0935,88.5,80.5);
	this.instance_4.alpha = 0.5;
	this.instance_4.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_4.cache(20,32,89,99);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:88.7,scaleX:0.1607,scaleY:0.9917,skewX:-0.7203,skewY:-53.3999,x:97.65,y:84.8},1).to({regX:88.5,scaleX:0.5441,scaleY:1.0072,skewX:-4.0199,skewY:-23.0935,x:95.5,y:83.75},1).to({scaleX:1,scaleY:1,rotation:-7.4135,skewX:0,skewY:0,x:93.15,y:84.85},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-7.3,-27.3,200,210.3);


(lib.DESCA1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Interpolación15("synched",0);
	this.instance.setTransform(100.15,84,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(48).to({startPosition:0},0).to({rotation:16.7383,x:100.1,y:84.05},23,cjs.Ease.cubicInOut).to({rotation:0,x:100.15,y:84},24,cjs.Ease.cubicInOut).wait(25));

	// ala2_png
	this.instance_1 = new lib.ALA22();
	this.instance_1.setTransform(98.95,74.35,0.5,1,0,0,0,-1.9,47.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({regY:47.4,scaleX:1,x:99,y:74.3},22,cjs.Ease.cubicInOut).to({scaleX:0.9,x:98.95},12,cjs.Ease.cubicInOut).to({scaleX:1,x:99},14,cjs.Ease.cubicInOut).to({scaleX:0.5,x:98.95},23,cjs.Ease.cubicInOut).to({scaleX:1,x:99},24,cjs.Ease.cubicInOut).to({regY:47.5,scaleX:0.5,x:98.95,y:74.35},24,cjs.Ease.cubicInOut).wait(1));

	// ala1_png
	this.instance_2 = new lib.ALA2();
	this.instance_2.setTransform(100.05,83.95,0.5,1,0,0,0,97.9,83);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({scaleX:1,x:100.1},22,cjs.Ease.cubicInOut).to({scaleX:0.9,x:100.05},12,cjs.Ease.cubicInOut).to({scaleX:1,x:100.1},14,cjs.Ease.cubicInOut).to({scaleX:0.5,x:100.05},23,cjs.Ease.cubicInOut).to({scaleX:1,x:100.1},24,cjs.Ease.cubicInOut).to({scaleX:0.5,x:100.05},24,cjs.Ease.cubicInOut).wait(1));

	// Capa_5
	this.instance_3 = new lib.Símbolo5();
	this.instance_3.setTransform(106.6,84.6,0.5,1,0,0,0,2.2,56.3);
	this.instance_3.alpha = 0.5;
	this.instance_3.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_3.cache(-6,-24,56,117);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regX:2,regY:56.2,scaleX:1,rotation:-7.4135,x:106.55},22,cjs.Ease.cubicInOut).to({scaleX:0.8996,scaleY:0.9996,rotation:-7.2939,x:106.6,y:84.5},12,cjs.Ease.cubicInOut).to({scaleX:1,scaleY:1,rotation:-7.4135,x:106.55,y:84.6},14,cjs.Ease.cubicInOut).to({regX:2.1,scaleX:0.4998,scaleY:0.9996,rotation:-7.2939,x:106.6,y:84.5},23,cjs.Ease.cubicInOut).to({regX:2,scaleX:1,scaleY:1,rotation:-7.4135,x:106.55,y:84.6},24,cjs.Ease.cubicInOut).to({regX:2.2,regY:56.3,scaleX:0.5,rotation:0,x:106.6},24,cjs.Ease.cubicInOut).wait(1));

	// Capa_4
	this.instance_4 = new lib.Símbolo4();
	this.instance_4.setTransform(93.15,84.8,0.5,1,0,0,0,88.5,80.5);
	this.instance_4.alpha = 0.5;
	this.instance_4.filters = [new cjs.BlurFilter(10, 10, 3)];
	this.instance_4.cache(20,32,89,99);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({scaleX:1,x:93.2},22,cjs.Ease.cubicInOut).to({scaleX:0.9,x:93.15},12,cjs.Ease.cubicInOut).to({scaleX:1,x:93.2},14,cjs.Ease.cubicInOut).to({scaleX:0.5,x:93.15},23,cjs.Ease.cubicInOut).to({scaleX:1,x:93.2},24,cjs.Ease.cubicInOut).to({scaleX:0.5,x:93.15},24,cjs.Ease.cubicInOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.7,-27.3,194.39999999999998,195.3);


(lib.Símbolo11 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Capa_1
	this.instance = new lib.Símbolo9copia("synched",0);
	this.instance.setTransform(594.1,97.55,1,1,-134.9994,0,0,10.7,10.7);

	this.instance_1 = new lib.Símbolo9("synched",0);
	this.instance_1.setTransform(602.3,111.75,0.6511,0.6511,-135,0,0,10.7,10.8);

	this.instance_2 = new lib.Símbolo9copia("synched",0);
	this.instance_2.setTransform(69.25,38.15,1,1,150.0008,0,0,10.7,10.8);

	this.instance_3 = new lib.Símbolo9("synched",0);
	this.instance_3.setTransform(885.45,186.4,0.6657,0.6657,143.5125,0,0,10.8,10.8);

	this.instance_4 = new lib.Símbolo9copia("synched",0);
	this.instance_4.setTransform(894.3,191.75,0.6657,0.6657,0,0,0,10.7,10.8);

	this.instance_5 = new lib.Símbolo9("synched",0);
	this.instance_5.setTransform(233.6,16.65,1.0986,1.0986,-141.4898,0,0,10.9,10.8);

	this.instance_6 = new lib.Símbolo9copia("synched",0);
	this.instance_6.setTransform(230.65,27.6,0.6657,0.6657,75.0005,0,0,10.7,10.8);

	this.instance_7 = new lib.Símbolo9copia("synched",0);
	this.instance_7.setTransform(806.5,61.55,1,1,150.0008,0,0,10.7,10.8);

	this.instance_8 = new lib.Símbolo9("synched",0);
	this.instance_8.setTransform(816.95,50.95,0.4663,0.4663,150.0021,0,0,10.7,10.8);

	this.instance_9 = new lib.Símbolo9copia("synched",0);
	this.instance_9.setTransform(612.95,243.5,1,1,0,105.0002,-74.9998,10.8,10.8);

	this.instance_10 = new lib.Símbolo9("synched",0);
	this.instance_10.setTransform(617.3,258.35,1,1,0,105.0002,-74.9998,10.7,10.8);

	this.instance_11 = new lib.Símbolo9copia("synched",0);
	this.instance_11.setTransform(476.4,236.4,1,1,0,0,0,10.8,10.8);

	this.instance_12 = new lib.Símbolo9("synched",0);
	this.instance_12.setTransform(460.5,232.1,0.6512,0.6512,0,0,0,10.8,10.8);

	this.instance_13 = new lib.Símbolo9("synched",0);
	this.instance_13.setTransform(323.4,297.95,0.4528,0.4528,0,-98.5116,81.4884,11,10.6);

	this.instance_14 = new lib.Símbolo9copia("synched",0);
	this.instance_14.setTransform(316.65,296.15,0.4528,0.4528,0,44.9973,-135.0027,10.6,10.8);

	this.instance_15 = new lib.Símbolo9("synched",0);
	this.instance_15.setTransform(329.25,253.9,0.6657,0.6657,-141.4887,0,0,10.8,10.8);

	this.instance_16 = new lib.Símbolo9copia("synched",0);
	this.instance_16.setTransform(326.35,263.85,0.6657,0.6657,75.0005,0,0,10.7,10.8);

	this.instance_17 = new lib.Símbolo9("synched",0);
	this.instance_17.setTransform(144.25,186.95,1,1,0,0,0,10.8,10.8);

	this.instance_18 = new lib.Símbolo9copia("synched",0);
	this.instance_18.setTransform(157.35,195,1,1,0,0,0,10.8,10.8);

	this.instance_19 = new lib.Símbolo9("synched",0);
	this.instance_19.setTransform(59.5,297,0.6657,0.6657,143.5125,0,0,10.8,10.8);

	this.instance_20 = new lib.Símbolo9copia("synched",0);
	this.instance_20.setTransform(68.35,302.35,0.6657,0.6657,0,0,0,10.7,10.8);

	this.instance_21 = new lib.Símbolo9copia("synched",0);
	this.instance_21.setTransform(23.65,240.65,1,1,0,0,0,10.8,10.8);

	this.instance_22 = new lib.Símbolo9("synched",0);
	this.instance_22.setTransform(10.55,232.6,1,1,0,0,0,10.8,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(48));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.2,-2,907.2,316);


// stage content:
(lib.mariposas = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [74,124];
	// timeline functions:
	this.frame_74 = function() {
		/* Hacer clic para ir a página Web
		Al hacer clic en la instancia del símbolo especificado, la dirección URL se carga en una nueva ventana del navegador.
		
		Instrucciones:
		1. Reemplace http://www.adobe.com por la dirección URL que desee.
		      Conserve las comillas ("").
		*/
		
		//this.btn_cerrar.addEventListener("click", fl_ClickToGoToWebPage_2);
		
		//function fl_ClickToGoToWebPage_2() {
			//window.open("https://www.google.com", "_blank");
		//}
		/* Hacer clic para ir a página Web
		Al hacer clic en la instancia del símbolo especificado, la dirección URL se carga en una nueva ventana del navegador.
		
		Instrucciones:
		1. Reemplace http://www.adobe.com por la dirección URL que desee.
		      Conserve las comillas ("").
		*/
		
		this.btn_link.addEventListener("click", fl_ClickToGoToWebPage);
		
		function fl_ClickToGoToWebPage() {
          cerrarAD()
			//window.open("https://cafequindiocolombia.myshopify.com/products/cafe-disney-encanto", "_self");
		}
	}
	this.frame_124 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(74).call(this.frame_74).wait(50).call(this.frame_124).wait(1));

	// copyrigh
	this.instance = new lib.Símbolo12();
	this.instance.setTransform(825.9,464.95,1,1,0,0,0,17.5,4.4);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(95).to({_off:false},0).to({alpha:1},16).wait(14));

	// BTN_CLOSE
	this.btn_cerrar = new lib.btnclose();
	this.btn_cerrar.name = "btn_cerrar";
	this.btn_cerrar.setTransform(1041.7,133.45,1,1,0,0,0,18.7,22.4);
	this.btn_cerrar._off = true;
	new cjs.ButtonHelper(this.btn_cerrar, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.btn_cerrar).wait(74).to({_off:false},0).wait(51));

	// BTN
	this.btn_link = new lib.btn_main();
	this.btn_link.name = "btn_link";
	this.btn_link.setTransform(633.55,337.65,0.7766,0.7883,0,0,0,567.9,299.9);
	this.btn_link._off = true;
	new cjs.ButtonHelper(this.btn_link, 0, 1, 2, false, new lib.btn_main(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_link).wait(74).to({_off:false},0).wait(51));

	// Símbolo_1
	this.instance_1 = new lib.DESCA11();
	this.instance_1.setTransform(769.2,60.5,0.7487,0.7487,-139.1476,0,0,106,67.2);
	this.instance_1._off = true;

	this.instance_2 = new lib.DESCA1();
	this.instance_2.setTransform(568.75,166.55,0.7488,0.7488,-144.6728,0,0,106,67.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1}]},12).to({state:[{t:this.instance_2}]},26).to({state:[{t:this.instance_1}]},35).to({state:[{t:this.instance_1}]},20).to({state:[]},1).wait(31));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(12).to({_off:false},0).to({_off:true,regY:67.1,scaleX:0.7488,scaleY:0.7488,rotation:-144.6728,x:568.75,y:166.55},26,cjs.Ease.cubicOut).wait(35).to({_off:false},0).to({regX:106.1,scaleX:0.7497,scaleY:0.7497,rotation:-174.7335,x:272.15,y:570.85,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(31));

	// Símbolo_1
	this.instance_3 = new lib.DESCA11();
	this.instance_3.setTransform(421.5,301.7,0.7869,0.7869,36.3215,0,0,106.2,67.2);
	this.instance_3._off = true;

	this.instance_4 = new lib.DESCA1();
	this.instance_4.setTransform(594,340.9,0.7869,0.7869,120.7866,0,0,106.1,67);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3}]},15).to({state:[{t:this.instance_4}]},26).to({state:[{t:this.instance_3}]},35).to({state:[{t:this.instance_3}]},20).to({state:[]},1).wait(28));
	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(15).to({_off:false},0).to({_off:true,regX:106.1,regY:67,rotation:120.7866,guide:{path:[421.4,301.7,478.7,262.2,593.9,340.8]}},26,cjs.Ease.cubicOut).wait(35).to({_off:false},0).to({regY:67.1,rotation:90.7855,x:948.8,y:379.35,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(28));

	// Símbolo_1_copia_4
	this.instance_5 = new lib.Símbolo1copia4();
	this.instance_5.setTransform(388.5,254.25,0.7869,0.7869,85.4801,0,0,106.2,67.1);
	this.instance_5.alpha = 0;
	this.instance_5._off = true;

	this.instance_6 = new lib.Símbolo1copia();
	this.instance_6.setTransform(631.7,196.3,0.7869,0.7869,-4.5219,0,0,106.2,67.5);

	this.instance_7 = new lib.Símbolo1copia2();
	this.instance_7.setTransform(621.7,186.25,0.7869,0.7869,-19.522,0,0,106.2,67.5);
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_5}]},14).to({state:[{t:this.instance_6,p:{rotation:-4.521900000000002,x:631.7,y:196.3,alpha:1}}]},26).to({state:[{t:this.instance_7}]},35).to({state:[{t:this.instance_6,p:{rotation:-34.5211,x:407.7,y:90.3,alpha:0}}]},20).to({state:[]},1).wait(29));
	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(14).to({_off:false},0).to({_off:true,regY:67.5,rotation:-4.5219,guide:{path:[388.5,254.2,551.3,318.4,631.6,196.2]},alpha:1},26,cjs.Ease.get(1)).wait(85));
	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(75).to({_off:false},0).to({_off:true,rotation:-34.5211,x:407.7,y:90.3,alpha:0},20,cjs.Ease.get(-1)).wait(30));

	// Símbolo_1_copia_3
	this.instance_8 = new lib.Símbolo1copia3();
	this.instance_8.setTransform(925.25,830.25,0.7869,0.7869,19.9248,0,0,106.4,67);
	this.instance_8._off = true;

	this.instance_9 = new lib.DESCA1();
	this.instance_9.setTransform(741.35,174,0.7869,0.7869,-40.0753,0,0,106.3,67.2);

	this.instance_10 = new lib.Símbolo1();
	this.instance_10.setTransform(741.4,173.95,0.7869,0.7869,-40.0753,0,0,106.4,67.2);
	this.instance_10._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_8}]},12).to({state:[{t:this.instance_9}]},26).to({state:[{t:this.instance_10}]},34).to({state:[{t:this.instance_10}]},20).to({state:[]},1).wait(32));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(12).to({_off:false},0).to({_off:true,regX:106.3,regY:67.2,rotation:-40.0753,x:741.35,y:174},26,cjs.Ease.cubicOut).wait(87));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(72).to({_off:false},0).to({regX:106.2,x:565.5,y:47.2,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(32));

	// Símbolo_1
	this.instance_11 = new lib.Símbolo1();
	this.instance_11.setTransform(454.5,794.8,0.787,0.787,-19.5202,0,0,106,67.2);
	this.instance_11.alpha = 0;
	this.instance_11._off = true;

	this.instance_12 = new lib.DESCA1();
	this.instance_12.setTransform(521.8,183.65,0.7869,0.7869,25.4809,0,0,106.2,67.2);
	this.instance_12._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(10).to({_off:false},0).to({_off:true,regX:106.2,scaleX:0.7869,scaleY:0.7869,rotation:25.4809,x:521.8,y:183.65,alpha:1},26,cjs.Ease.quadOut).wait(34).to({_off:false,regY:67,scaleX:0.787,scaleY:0.787,rotation:70.4798,x:850.15,y:95.45,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(34));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(10).to({_off:false},26,cjs.Ease.quadOut).wait(34).to({rotation:25.4809},0).to({_off:true,regY:67,scaleX:0.787,scaleY:0.787,rotation:70.4798,x:850.15,y:95.45,alpha:0},20,cjs.Ease.cubicIn).wait(35));

	// Símbolo_1_copia_3
	this.instance_13 = new lib.Símbolo1copia3();
	this.instance_13.setTransform(849.3,47.45,0.7869,0.7869,-104.2127,0,0,106,67.2);
	this.instance_13.alpha = 0;
	this.instance_13._off = true;

	this.instance_14 = new lib.Símbolo1copia();
	this.instance_14.setTransform(680.65,198.45,0.7869,0.7869,120.7866,0,0,106.2,67.2);

	this.instance_15 = new lib.Símbolo1();
	this.instance_15.setTransform(680.65,203.45,0.7869,0.7869,120.7866,0,0,106.2,67.2);
	this.instance_15._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_13}]},8).to({state:[{t:this.instance_14}]},26).to({state:[{t:this.instance_15}]},33).to({state:[{t:this.instance_15}]},20).to({state:[]},1).wait(37));
	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(8).to({_off:false},0).to({_off:true,regX:106.2,rotation:-239.2134,guide:{path:[849.3,47.6,747.5,84.3,705.3,122,663.1,159.8,680.4,198.6]},alpha:1},26,cjs.Ease.cubicOut).wait(91));
	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(67).to({_off:false},0).to({x:1097.95,y:340.65,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(37));

	// Símbolo_1
	this.instance_16 = new lib.DESCA11();
	this.instance_16.setTransform(889.1,40.55,0.9999,0.9999,130.8434,0,0,106,67.2);
	this.instance_16._off = true;

	this.instance_17 = new lib.DESCA1();
	this.instance_17.setTransform(948.8,329.5,0.9999,0.9999,-144.6915,0,0,106.1,67.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_16}]},12).to({state:[{t:this.instance_17}]},26).to({state:[{t:this.instance_16}]},35).to({state:[{t:this.instance_16}]},20).to({state:[]},1).wait(31));
	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(12).to({_off:false},0).to({_off:true,regX:106.1,rotation:215.3085,guide:{path:[889.1,40.7,1133.4,100.3,948.8,329.5]}},26,cjs.Ease.cubicOut).wait(35).to({_off:false},0).to({rotation:185.3089,x:812.1,y:630.85,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(31));

	// Símbolo_1_copia_4
	this.instance_18 = new lib.Símbolo1copia4();
	this.instance_18.setTransform(592.75,22.5,0.9999,0.9999,-119.998,0,0,106.1,67.2);
	this.instance_18.alpha = 0;
	this.instance_18._off = true;

	this.instance_19 = new lib.Símbolo1copia();
	this.instance_19.setTransform(646.1,367.45,0.9999,0.9999,150.0021,0,0,106.2,67.3);

	this.instance_20 = new lib.Símbolo1copia3();
	this.instance_20.setTransform(606.2,387.5,0.9999,0.9999,-164.9989,0,0,106.1,67.2);
	this.instance_20._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_18}]},11).to({state:[{t:this.instance_19}]},26).to({state:[{t:this.instance_20}]},35).to({state:[{t:this.instance_20}]},20).to({state:[]},1).wait(32));
	this.timeline.addTween(cjs.Tween.get(this.instance_18).wait(11).to({_off:false},0).to({_off:true,regX:106.2,regY:67.3,rotation:-209.9979,x:646.1,y:367.45,alpha:1},26,cjs.Ease.get(1)).wait(88));
	this.timeline.addTween(cjs.Tween.get(this.instance_20).wait(72).to({_off:false},0).to({x:539.95,y:517.55,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(32));

	// Símbolo_1_copia_3
	this.instance_21 = new lib.Símbolo1copia3();
	this.instance_21.setTransform(1018.5,17.15,0.9999,0.9999,-104.9993,0,0,106.2,67);
	this.instance_21._off = true;

	this.instance_22 = new lib.DESCA1();
	this.instance_22.setTransform(816.95,330.55,0.9999,0.9999,-164.9989,0,0,106.1,67.2);

	this.instance_23 = new lib.Símbolo1();
	this.instance_23.setTransform(816.95,350.55,0.9999,0.9999,-164.9989,0,0,106.1,67.2);
	this.instance_23._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_21}]},9).to({state:[{t:this.instance_22}]},26).to({state:[{t:this.instance_23}]},34).to({state:[{t:this.instance_23}]},20).to({state:[]},1).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).wait(9).to({_off:false},0).to({_off:true,regX:106.1,regY:67.2,rotation:-164.9989,guide:{path:[1018.6,17.2,890.2,68.6,817,330.5]}},26,cjs.Ease.cubicOut).wait(90));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).wait(69).to({_off:false},0).to({x:839.7,y:515.5,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(35));

	// Símbolo_1
	this.instance_24 = new lib.Símbolo1();
	this.instance_24.setTransform(85.15,185.85,1,1,75.0018,0,0,106,67.2);
	this.instance_24.alpha = 0;
	this.instance_24._off = true;

	this.instance_25 = new lib.DESCA1();
	this.instance_25.setTransform(494.5,405.65,1,1,165.0018,0,0,106,67.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_24}]},7).to({state:[{t:this.instance_25}]},26).to({state:[{t:this.instance_24}]},34).to({state:[{t:this.instance_24}]},20).to({state:[]},1).wait(37));
	this.timeline.addTween(cjs.Tween.get(this.instance_24).wait(7).to({_off:false},0).to({_off:true,rotation:165.0018,x:494.5,y:405.65,alpha:1},26,cjs.Ease.quadOut).wait(34).to({_off:false},0).to({x:662.95,y:646.15,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(37));

	// Símbolo_1_copia_3
	this.instance_26 = new lib.Símbolo1copia3();
	this.instance_26.setTransform(726.25,606.7,0.9999,0.9999,-0.0009,0,0,106,67.2);
	this.instance_26.alpha = 0;
	this.instance_26._off = true;

	this.instance_27 = new lib.Símbolo1copia();
	this.instance_27.setTransform(617.85,418.6,0.9998,0.9998,-0.0009,0,0,106.1,67.2);

	this.instance_28 = new lib.Símbolo1();
	this.instance_28.setTransform(626.85,416.4,0.9999,0.9999,-144.6915,0,0,106.1,67.2);
	this.instance_28._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_26}]},5).to({state:[{t:this.instance_27}]},26).to({state:[{t:this.instance_28}]},33).to({state:[{t:this.instance_28}]},20).to({state:[]},1).wait(40));
	this.timeline.addTween(cjs.Tween.get(this.instance_26).wait(5).to({_off:false},0).to({_off:true,regX:106.1,scaleX:0.9998,scaleY:0.9998,x:617.85,y:418.6,alpha:1},26,cjs.Ease.cubicOut).wait(94));
	this.timeline.addTween(cjs.Tween.get(this.instance_28).wait(64).to({_off:false},0).to({x:199.65,y:619.55,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(40));

	// Símbolo_1_copia_2
	this.instance_29 = new lib.Símbolo1copia2();
	this.instance_29.setTransform(1308.6,357.65,0.9999,0.9999,-53.9394,0,0,106,67);
	this.instance_29.alpha = 0;
	this.instance_29._off = true;

	this.instance_30 = new lib.Símbolo1copia();
	this.instance_30.setTransform(972.85,479.2,1,1,165.0015,0,0,106,67);

	this.instance_31 = new lib.Símbolo1();
	this.instance_31.setTransform(952.85,479.2,1,1,165.0015,0,0,106,67);
	this.instance_31._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_29}]},3).to({state:[{t:this.instance_30}]},26).to({state:[{t:this.instance_31}]},33).to({state:[{t:this.instance_31}]},20).to({state:[]},1).wait(42));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).wait(3).to({_off:false},0).to({_off:true,scaleX:1,scaleY:1,rotation:-194.9985,x:972.85,y:479.2,alpha:1},26,cjs.Ease.cubicOut).wait(96));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).wait(62).to({_off:false},0).to({regY:67.1,scaleX:0.9999,scaleY:0.9999,rotation:135.0025,x:1088.7,y:533.75,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(42));

	// Símbolo_1
	this.instance_32 = new lib.Símbolo1();
	this.instance_32.setTransform(310.9,-47.75,0.7506,0.8197,150.0017,0,0,106.1,67);
	this.instance_32._off = true;

	this.instance_33 = new lib.Símbolo1copia();
	this.instance_33.setTransform(396,369.95,0.7506,0.8198,180,0,0,106.1,67);

	this.instance_34 = new lib.Símbolo1copia4();
	this.instance_34.setTransform(396,369.95,0.7506,0.8198,180,0,0,106.1,67);
	this.instance_34._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_32}]},15).to({state:[{t:this.instance_33}]},26).to({state:[{t:this.instance_34}]},33).to({state:[{t:this.instance_34}]},20).to({state:[]},1).wait(30));
	this.timeline.addTween(cjs.Tween.get(this.instance_32).wait(15).to({_off:false},0).to({_off:true,scaleY:0.8198,rotation:180,guide:{path:[310.8,-47.6,434.5,156.1,396,369.9]}},26,cjs.Ease.get(1)).wait(84));
	this.timeline.addTween(cjs.Tween.get(this.instance_34).wait(74).to({_off:false},0).to({x:376,y:689.4,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(30));

	// Símbolo_1
	this.instance_35 = new lib.Símbolo1();
	this.instance_35.setTransform(1232.45,165.1,0.7506,0.8198,-90,0,0,106.1,67);
	this.instance_35.alpha = 0;
	this.instance_35._off = true;

	this.instance_36 = new lib.Símbolo1copia();
	this.instance_36.setTransform(867.7,464.45,0.7506,0.8198,180,0,0,106.1,67);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_35}]},13).to({state:[{t:this.instance_36}]},26).to({state:[{t:this.instance_35}]},33).to({state:[{t:this.instance_35}]},20).to({state:[]},1).wait(32));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).wait(13).to({_off:false},0).to({_off:true,rotation:-180,guide:{path:[1232.5,165.3,920.8,186,871.3,465.1]},alpha:1},26,cjs.Ease.quadInOut).wait(33).to({_off:false,y:454.45},0).to({x:956.05,y:686.9,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(32));

	// Símbolo_1
	this.instance_37 = new lib.Símbolo1copia3();
	this.instance_37.setTransform(645,11.65,0.7505,0.8197,135,0,0,106.2,67.1);
	this.instance_37.alpha = 0;
	this.instance_37._off = true;

	this.instance_38 = new lib.Símbolo1copia();
	this.instance_38.setTransform(969.45,384.35,0.7505,0.8197,149.9995,0,0,106.2,67.1);

	this.instance_39 = new lib.Símbolo1();
	this.instance_39.setTransform(969.45,384.35,0.7505,0.8197,149.9995,0,0,106.2,67.1);
	this.instance_39._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_37}]},11).to({state:[{t:this.instance_38}]},26).to({state:[{t:this.instance_39}]},33).to({state:[{t:this.instance_39}]},20).to({state:[]},1).wait(34));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).wait(11).to({_off:false},0).to({_off:true,rotation:149.9995,guide:{path:[645.1,11.7,833.2,136.8,969.5,384.4]},alpha:1},26).wait(88));
	this.timeline.addTween(cjs.Tween.get(this.instance_39).wait(70).to({_off:false},0).to({regY:67.2,rotation:120.0006,x:1256.85,y:356.2,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(34));

	// Símbolo_1
	this.instance_40 = new lib.Símbolo1copia4();
	this.instance_40.setTransform(844.75,599.35,0.7505,0.8197,-33.2102,0,0,106.2,67.1);
	this.instance_40.alpha = 0;
	this.instance_40._off = true;

	this.instance_41 = new lib.Símbolo1copia();
	this.instance_41.setTransform(514.15,318.75,0.7505,0.8197,-150.0019,0,0,106.2,67.1);

	this.instance_42 = new lib.Símbolo1();
	this.instance_42.setTransform(514.15,318.75,0.7505,0.8197,-150.0019,0,0,106.2,67.1);
	this.instance_42._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_40}]},10).to({state:[{t:this.instance_41}]},26).to({state:[{t:this.instance_42}]},33).to({state:[{t:this.instance_42}]},20).to({state:[]},1).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.instance_40).wait(10).to({_off:false},0).to({_off:true,rotation:-150.0019,guide:{path:[844.8,599.4,735.4,386.6,652.5,316.3,569.7,246,513.5,318.2]},alpha:1},26,cjs.Ease.cubicOut).wait(89));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).wait(69).to({_off:false},0).to({x:527.65,y:157.65,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(35));

	// AAAAAAAAAAAAAAAAAAAAAAAAA
	this.instance_43 = new lib.DESCA11();
	this.instance_43.setTransform(116.3,36.7,0.7505,0.8197,135.0015,0,0,106.2,67.2);
	this.instance_43._off = true;

	this.instance_44 = new lib.DESCA1();
	this.instance_44.setTransform(290,330.25,0.7505,0.8197,179.9989,0,0,106.1,67.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_43}]},8).to({state:[{t:this.instance_44}]},26).to({state:[{t:this.instance_43}]},33).to({state:[{t:this.instance_43}]},20).to({state:[]},1).wait(37));
	this.timeline.addTween(cjs.Tween.get(this.instance_43).wait(8).to({_off:false},0).to({_off:true,regX:106.1,regY:67.1,rotation:179.9989,guide:{path:[116.4,36.8,120,87.8,146,117.2,157.6,130.4,176.3,142.3,183.1,146.5,210.6,161.6,231.9,173.2,243.9,182.5,261.1,195.9,271.5,212.7,296.9,253.8,290,330.2]}},26,cjs.Ease.quadInOut).wait(33).to({_off:false},0).to({regX:106.2,regY:67.2,rotation:234.2328,x:123,y:541.3,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(37));

	// Símbolo_1
	this.instance_45 = new lib.Símbolo1copia2();
	this.instance_45.setTransform(1161.7,70,0.7505,0.8197,-165.0014,0,0,106.3,67.2);
	this.instance_45.alpha = 0;
	this.instance_45._off = true;

	this.instance_46 = new lib.Símbolo1copia();
	this.instance_46.setTransform(1021.2,325.15,0.7505,0.8197,-135.0015,0,0,106.2,67);

	this.instance_47 = new lib.Símbolo1copia3();
	this.instance_47.setTransform(1021.2,325.15,0.7505,0.8197,-135.0015,0,0,106.2,67);
	this.instance_47._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_45}]},6).to({state:[{t:this.instance_46}]},26).to({state:[{t:this.instance_47}]},33).to({state:[{t:this.instance_47}]},20).to({state:[]},1).wait(39));
	this.timeline.addTween(cjs.Tween.get(this.instance_45).wait(6).to({_off:false},0).to({_off:true,regX:106.2,regY:67,rotation:-135.0015,guide:{path:[1161.7,70.1,1151.6,219.2,1021.2,325.1]},alpha:1},26,cjs.Ease.cubicOut).wait(93));
	this.timeline.addTween(cjs.Tween.get(this.instance_47).wait(65).to({_off:false},0).to({x:1136.35,y:96.35,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(39));

	// Símbolo_1
	this.instance_48 = new lib.Símbolo1copia3();
	this.instance_48.setTransform(540,10.3,0.7505,0.8197,-135.0023,0,0,106.2,67.2);
	this.instance_48.alpha = 0;
	this.instance_48._off = true;

	this.instance_49 = new lib.Símbolo1copia();
	this.instance_49.setTransform(456.3,429.45,0.7505,0.8197,179.9989,0,0,106.1,67.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_48}]},5).to({state:[{t:this.instance_49}]},26).to({state:[{t:this.instance_48}]},33).to({state:[{t:this.instance_48}]},20).to({state:[]},1).wait(40));
	this.timeline.addTween(cjs.Tween.get(this.instance_48).wait(5).to({_off:false},0).to({_off:true,regX:106.1,regY:67.1,rotation:-180.0011,x:456.3,y:429.45,alpha:1},26,cjs.Ease.get(1)).wait(33).to({_off:false},0).to({x:481,y:668.1,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(40));

	// Símbolo_1
	this.instance_50 = new lib.Símbolo1();
	this.instance_50.setTransform(1003.15,50.95,0.7505,0.8197,-135,0,0,106.2,67);
	this.instance_50.alpha = 0;
	this.instance_50._off = true;

	this.instance_51 = new lib.Símbolo1copia();
	this.instance_51.setTransform(825.2,455,0.7506,0.8198,180,0,0,106.1,67);

	this.instance_52 = new lib.Símbolo1copia3();
	this.instance_52.setTransform(825.2,455,0.7506,0.8198,180,0,0,106.1,67);
	this.instance_52._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_50}]},3).to({state:[{t:this.instance_51}]},26).to({state:[{t:this.instance_52}]},33).to({state:[{t:this.instance_52}]},20).to({state:[]},1).wait(42));
	this.timeline.addTween(cjs.Tween.get(this.instance_50).wait(3).to({_off:false},0).to({_off:true,regX:106.1,scaleX:0.7506,scaleY:0.8198,rotation:-180,guide:{path:[1003.1,51.1,839.4,210,825.2,455]},alpha:1},26,cjs.Ease.quadInOut).wait(96));
	this.timeline.addTween(cjs.Tween.get(this.instance_52).wait(62).to({_off:false},0).to({regY:67.1,scaleX:0.7505,scaleY:0.8197,rotation:135,x:878.65,y:629.45,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(42));

	// Símbolo_1
	this.instance_53 = new lib.Símbolo1();
	this.instance_53.setTransform(227.7,745.2,0.5838,0.6376,-36.7021,0,0,106.2,67.1);
	this.instance_53.alpha = 0;
	this.instance_53._off = true;

	this.instance_54 = new lib.Símbolo1copia();
	this.instance_54.setTransform(392.6,317.9,0.5838,0.6376,29.9986,0,0,106.2,67.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_53}]},9).to({state:[{t:this.instance_54}]},26).to({state:[{t:this.instance_53}]},33).to({state:[{t:this.instance_53}]},20).to({state:[]},1).wait(36));
	this.timeline.addTween(cjs.Tween.get(this.instance_53).wait(9).to({_off:false},0).to({_off:true,rotation:29.9986,guide:{path:[227.7,745.2,115.9,569.1,392.6,318]},alpha:1},26,cjs.Ease.quadInOut).wait(33).to({_off:false,rotation:29.9986},0).to({x:357.65,y:109.1,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(36));

	// Símbolo_1
	this.instance_55 = new lib.Símbolo1();
	this.instance_55.setTransform(1204,762.45,0.5838,0.6376,-59.9971,0,0,106.1,67);
	this.instance_55.alpha = 0;
	this.instance_55._off = true;

	this.instance_56 = new lib.Símbolo1copia();
	this.instance_56.setTransform(904.3,318.1,0.5838,0.6376,-14.998,0,0,106.2,67);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_55}]},7).to({state:[{t:this.instance_56}]},26).to({state:[{t:this.instance_55}]},33).to({state:[{t:this.instance_55}]},20).to({state:[]},1).wait(38));
	this.timeline.addTween(cjs.Tween.get(this.instance_55).wait(7).to({_off:false},0).to({_off:true,regX:106.2,rotation:-14.998,guide:{path:[1204.1,762.4,904.2,580.3,904.3,318.2]},alpha:1},26,cjs.Ease.cubicOut).wait(33).to({_off:false,rotation:-14.998},0).to({x:944.75,y:70.8,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(38));

	// Símbolo_1
	this.instance_57 = new lib.Símbolo1();
	this.instance_57.setTransform(555.1,783.7,0.5838,0.6376,68.472,0,0,106,67);
	this.instance_57._off = true;

	this.instance_58 = new lib.Símbolo1copia();
	this.instance_58.setTransform(763.35,433.2,0.5838,0.6376,0,0,0,106.1,67);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_57}]},5).to({state:[{t:this.instance_58}]},26).to({state:[{t:this.instance_57}]},32).to({state:[{t:this.instance_57}]},20).to({state:[]},1).wait(41));
	this.timeline.addTween(cjs.Tween.get(this.instance_57).wait(5).to({_off:false},0).to({_off:true,regX:106.1,rotation:0,guide:{path:[555.1,783.7,818.8,707.5,763.3,433.3]}},26,cjs.Ease.cubicInOut).wait(32).to({_off:false},0).to({x:713.85,y:54.85,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(41));

	// Símbolo_1
	this.instance_59 = new lib.DESCA11();
	this.instance_59.setTransform(701.1,20.4,0.5838,0.6376,149.999,0,0,106.2,67.2);
	this.instance_59.alpha = 0;
	this.instance_59._off = true;

	this.instance_60 = new lib.DESCA1();
	this.instance_60.setTransform(729.8,371.95,0.5837,0.6376,179.9986,0,0,106.1,67.2);

	this.instance_61 = new lib.Símbolo1copia4();
	this.instance_61.setTransform(726.8,380.4,0.5838,0.6376,-165.002,0,0,106.2,67.2);
	this.instance_61._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_59}]},3).to({state:[{t:this.instance_60}]},26).to({state:[{t:this.instance_61}]},33).to({state:[{t:this.instance_61}]},20).to({state:[]},1).wait(42));
	this.timeline.addTween(cjs.Tween.get(this.instance_59).wait(3).to({_off:false},0).to({_off:true,regX:106.1,scaleX:0.5837,rotation:179.9986,guide:{path:[701.1,20.5,852.8,147.4,731.1,372.6]},alpha:1},26,cjs.Ease.get(1)).wait(96));
	this.timeline.addTween(cjs.Tween.get(this.instance_61).wait(62).to({_off:false},0).to({x:709.15,y:666.8,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(42));

	// Símbolo_1
	this.instance_62 = new lib.Símbolo1();
	this.instance_62.setTransform(427.9,724.7,0.9999,0.9999,-49.1566,0,0,106,67.2);
	this.instance_62._off = true;

	this.instance_63 = new lib.Símbolo1copia();
	this.instance_63.setTransform(368.2,435.75,0.9999,0.9999,35.3085,0,0,106.1,67.2);

	this.instance_64 = new lib.Símbolo1copia4();
	this.instance_64.setTransform(368.2,435.75,0.9999,0.9999,35.3085,0,0,106.1,67.2);
	this.instance_64._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_62}]},5).to({state:[{t:this.instance_63}]},26).to({state:[{t:this.instance_64}]},35).to({state:[{t:this.instance_64}]},20).to({state:[]},1).wait(38));
	this.timeline.addTween(cjs.Tween.get(this.instance_62).wait(5).to({_off:false},0).to({_off:true,regX:106.1,rotation:35.3085,guide:{path:[427.9,724.7,183.7,665,368.2,435.7]}},26,cjs.Ease.cubicOut).wait(94));
	this.timeline.addTween(cjs.Tween.get(this.instance_64).wait(66).to({_off:false},0).to({rotation:5.3088,x:504.9,y:134.4,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(38));

	// Símbolo_1_copia_4
	this.instance_65 = new lib.Símbolo1copia4();
	this.instance_65.setTransform(773.25,755.3,0.9999,0.9999,-44.9981,0,0,106.1,67.2);
	this.instance_65.alpha = 0;
	this.instance_65._off = true;

	this.instance_66 = new lib.Símbolo1copia();
	this.instance_66.setTransform(690.9,417.8,0.9999,0.9999,-29.9979,0,0,106.2,67.3);

	this.instance_67 = new lib.Símbolo1copia3();
	this.instance_67.setTransform(690.8,417.75,0.9999,0.9999,15.0011,0,0,106.1,67.2);
	this.instance_67._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_65}]},4).to({state:[{t:this.instance_66}]},26).to({state:[{t:this.instance_67}]},35).to({state:[{t:this.instance_67}]},20).to({state:[]},1).wait(39));
	this.timeline.addTween(cjs.Tween.get(this.instance_65).wait(4).to({_off:false},0).to({_off:true,regX:106.2,regY:67.3,rotation:-29.9979,x:690.9,y:417.8,alpha:1},26,cjs.Ease.get(1)).wait(95));
	this.timeline.addTween(cjs.Tween.get(this.instance_67).wait(65).to({_off:false},0).to({x:777.05,y:247.7,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(39));

	// Símbolo_1_copia_3
	this.instance_68 = new lib.Símbolo1copia3();
	this.instance_68.setTransform(284.2,760.45,0.9999,0.9999,75.0007,0,0,106.2,67);
	this.instance_68._off = true;

	this.instance_69 = new lib.Símbolo1copia();
	this.instance_69.setTransform(560.05,434.7,0.9999,0.9999,15.0011,0,0,106.1,67.2);

	this.instance_70 = new lib.Símbolo1();
	this.instance_70.setTransform(560.05,434.7,0.9999,0.9999,15.0011,0,0,106.1,67.2);
	this.instance_70._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_68}]},3).to({state:[{t:this.instance_69}]},26).to({state:[{t:this.instance_70}]},34).to({state:[{t:this.instance_70}]},20).to({state:[]},1).wait(41));
	this.timeline.addTween(cjs.Tween.get(this.instance_68).wait(3).to({_off:false},0).to({_off:true,regX:106.1,regY:67.2,rotation:15.0011,guide:{path:[284.2,760.5,466.9,768.3,560.1,434.8]}},26,cjs.Ease.cubicOut).wait(96));
	this.timeline.addTween(cjs.Tween.get(this.instance_70).wait(63).to({_off:false},0).to({x:507.3,y:649.75,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(41));

	// Símbolo_1
	this.instance_71 = new lib.Símbolo1();
	this.instance_71.setTransform(1231.85,579.4,1,1,-104.9982,0,0,106,67.2);
	this.instance_71.alpha = 0;
	this.instance_71._off = true;

	this.instance_72 = new lib.Símbolo1copia();
	this.instance_72.setTransform(762.5,329.6,1,1,-14.9982,0,0,106,67.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_71}]},2).to({state:[{t:this.instance_72}]},26).to({state:[{t:this.instance_71}]},34).to({state:[{t:this.instance_71}]},20).to({state:[]},1).wait(42));
	this.timeline.addTween(cjs.Tween.get(this.instance_71).wait(2).to({_off:false},0).to({_off:true,rotation:-14.9982,guide:{path:[1231.8,579.4,761.1,693.8,762.5,329.5]},alpha:1},26,cjs.Ease.quadOut).wait(34).to({_off:false,rotation:-14.9982},0).to({x:654.05,y:119.1,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(42));

	// Símbolo_1_copia_3
	this.instance_73 = new lib.Símbolo1copia3();
	this.instance_73.setTransform(717.1,163.65,0.9999,0.9999,170.3097,0,0,106,67.1);
	this.instance_73.alpha = 0;
	this.instance_73._off = true;

	this.instance_74 = new lib.Símbolo1copia();
	this.instance_74.setTransform(990.15,348.85,0.9999,0.9999,35.3085,0,0,106.1,67.2);

	this.instance_75 = new lib.Símbolo1();
	this.instance_75.setTransform(990.15,348.85,0.9999,0.9999,35.3085,0,0,106.1,67.2);
	this.instance_75._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_73}]},1).to({state:[{t:this.instance_74}]},26).to({state:[{t:this.instance_75}]},33).to({state:[{t:this.instance_75}]},20).to({state:[]},1).wait(44));
	this.timeline.addTween(cjs.Tween.get(this.instance_73).wait(1).to({_off:false},0).to({_off:true,regX:106.1,regY:67.2,rotation:35.3085,guide:{path:[717,163.8,821.6,586.7,990.2,348.8]},alpha:1},26,cjs.Ease.cubicOut).wait(98));
	this.timeline.addTween(cjs.Tween.get(this.instance_75).wait(60).to({_off:false},0).to({x:1117.35,y:145.7,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(44));

	// Símbolo_1_copia_2
	this.instance_76 = new lib.Símbolo1copia2();
	this.instance_76.setTransform(8.4,407.6,0.9999,0.9999,126.0606,0,0,106,67);
	this.instance_76.alpha = 0;

	this.instance_77 = new lib.Símbolo1copia();
	this.instance_77.setTransform(364.15,286.05,1,1,-14.9985,0,0,106,67);

	this.instance_78 = new lib.Símbolo1();
	this.instance_78.setTransform(364.15,286.05,1,1,-14.9985,0,0,106,67);
	this.instance_78._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_76}]}).to({state:[{t:this.instance_77}]},26).to({state:[{t:this.instance_78}]},33).to({state:[{t:this.instance_78}]},20).to({state:[]},1).wait(45));
	this.timeline.addTween(cjs.Tween.get(this.instance_76).to({_off:true,scaleX:1,scaleY:1,rotation:-14.9985,guide:{path:[8.5,407.6,461.5,530.5,364.1,286.1]},alpha:1},26,cjs.Ease.cubicOut).wait(99));
	this.timeline.addTween(cjs.Tween.get(this.instance_78).wait(59).to({_off:false},0).to({regY:67.1,scaleX:0.9999,scaleY:0.9999,rotation:-44.9969,x:228.3,y:231.5,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(45));

	// Símbolo_1
	this.instance_79 = new lib.Símbolo1();
	this.instance_79.setTransform(1006.1,813,0.7506,0.8198,-29.9993,0,0,106.1,67);
	this.instance_79._off = true;

	this.instance_80 = new lib.Símbolo1copia();
	this.instance_80.setTransform(921,395.3,0.7506,0.8198,0,0,0,106.1,67);

	this.instance_81 = new lib.Símbolo1copia4();
	this.instance_81.setTransform(921,395.3,0.7506,0.8198,0,0,0,106.1,67);
	this.instance_81._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_79}]},7).to({state:[{t:this.instance_80}]},26).to({state:[{t:this.instance_81}]},33).to({state:[{t:this.instance_81}]},20).to({state:[]},1).wait(38));
	this.timeline.addTween(cjs.Tween.get(this.instance_79).wait(7).to({_off:false},0).to({_off:true,rotation:0,guide:{path:[1006.2,813,882.5,609.2,921,395.4]}},26,cjs.Ease.get(1)).wait(92));
	this.timeline.addTween(cjs.Tween.get(this.instance_81).wait(66).to({_off:false},0).to({y:215.85,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(38));

	// Símbolo_1
	this.instance_82 = new lib.Símbolo1();
	this.instance_82.setTransform(34.8,691.1,0.7506,0.8198,90,0,0,106.1,67);
	this.instance_82.alpha = 0;
	this.instance_82._off = true;

	this.instance_83 = new lib.Símbolo1copia();
	this.instance_83.setTransform(449.3,380.8,0.7506,0.8198,0,0,0,106.1,67);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_82}]},6).to({state:[{t:this.instance_83}]},26).to({state:[{t:this.instance_82}]},33).to({state:[{t:this.instance_82}]},20).to({state:[]},1).wait(39));
	this.timeline.addTween(cjs.Tween.get(this.instance_82).wait(6).to({_off:false},0).to({_off:true,rotation:0,guide:{path:[34.8,691.9,399.8,691.8,449.3,380.9]},alpha:1},26,cjs.Ease.quadInOut).wait(33).to({_off:false},0).to({x:360.95,y:158.35,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(39));

	// Símbolo_1
	this.instance_84 = new lib.Símbolo1copia3();
	this.instance_84.setTransform(672,753.6,0.7505,0.8197,-45,0,0,106.2,67.1);
	this.instance_84.alpha = 0;
	this.instance_84._off = true;

	this.instance_85 = new lib.Símbolo1copia();
	this.instance_85.setTransform(347.55,380.9,0.7505,0.8197,-30.0014,0,0,106.2,67.1);

	this.instance_86 = new lib.Símbolo1();
	this.instance_86.setTransform(347.55,380.9,0.7505,0.8197,-30.0014,0,0,106.2,67.1);
	this.instance_86._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_84}]},5).to({state:[{t:this.instance_85}]},26).to({state:[{t:this.instance_86}]},33).to({state:[{t:this.instance_86}]},20).to({state:[]},1).wait(40));
	this.timeline.addTween(cjs.Tween.get(this.instance_84).wait(5).to({_off:false},0).to({_off:true,rotation:-30.0014,guide:{path:[672,753.6,483.8,628.5,347.5,380.9]},alpha:1},26).wait(94));
	this.timeline.addTween(cjs.Tween.get(this.instance_86).wait(64).to({_off:false},0).to({regY:67.2,rotation:-59.9999,x:180.15,y:409.05,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(40));

	// Símbolo_1
	this.instance_87 = new lib.Símbolo1copia4();
	this.instance_87.setTransform(472.25,165.9,0.7505,0.8197,146.7898,0,0,106.2,67.1);
	this.instance_87.alpha = 0;
	this.instance_87._off = true;

	this.instance_88 = new lib.DESCA1();
	this.instance_88.setTransform(822.85,416.5,0.7505,0.8197,29.9981,0,0,106.2,67.1);

	this.instance_89 = new lib.Símbolo1();
	this.instance_89.setTransform(822.85,416.5,0.7505,0.8197,29.9981,0,0,106.2,67.1);
	this.instance_89._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_87}]},4).to({state:[{t:this.instance_88}]},26).to({state:[{t:this.instance_89}]},33).to({state:[{t:this.instance_89}]},20).to({state:[]},1).wait(41));
	this.timeline.addTween(cjs.Tween.get(this.instance_87).wait(4).to({_off:false},0).to({_off:true,rotation:29.9981,guide:{path:[472.2,166,591.5,397.8,679.1,460.4,766.8,523.1,822.8,416.5]},alpha:1},26,cjs.Ease.cubicOut).wait(95));
	this.timeline.addTween(cjs.Tween.get(this.instance_89).wait(63).to({_off:false},0).to({x:789.35,y:527.6,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(41));

	// Símbolo_1
	this.instance_90 = new lib.Símbolo1copia2();
	this.instance_90.setTransform(1200.7,728.55,0.7505,0.8197,-44.9985,0,0,106.2,67.2);
	this.instance_90._off = true;

	this.instance_91 = new lib.Símbolo1copiacopia2();
	this.instance_91.setTransform(939.65,435.1,0.6018,0.6572,-38.551,0,0,106.1,67.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_90}]},3).to({state:[{t:this.instance_91}]},26).wait(96));
	this.timeline.addTween(cjs.Tween.get(this.instance_90).wait(3).to({_off:false},0).to({_off:true,regX:106.1,regY:67.3,scaleX:0.6018,scaleY:0.6572,rotation:-38.551,x:939.65,y:435.1},26,cjs.Ease.quadInOut).wait(96));

	// Símbolo_1
	this.instance_92 = new lib.Símbolo1copia2();
	this.instance_92.setTransform(159.15,695.75,0.7505,0.8197,14.9983,0,0,106.3,67.2);
	this.instance_92.alpha = 0;
	this.instance_92._off = true;

	this.instance_93 = new lib.Símbolo1copia();
	this.instance_93.setTransform(335.15,448.45,0.5052,0.5517,-23.2161,0,0,106.4,67);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_92}]},2).to({state:[{t:this.instance_93}]},26).wait(97));
	this.timeline.addTween(cjs.Tween.get(this.instance_92).wait(2).to({_off:false},0).to({_off:true,regX:106.4,regY:67,scaleX:0.5052,scaleY:0.5517,rotation:-23.2161,guide:{path:[159.2,695.7,177.8,549,335.4,448.9]},alpha:1},26,cjs.Ease.cubicOut).wait(97));

	// Símbolo_1
	this.instance_94 = new lib.Símbolo1copia3();
	this.instance_94.setTransform(782.9,761.15,0.7505,0.8197,44.9977,0,0,106.2,67.2);
	this.instance_94.alpha = 0;
	this.instance_94._off = true;

	this.instance_95 = new lib.Símbolo1copia();
	this.instance_95.setTransform(870.7,355.8,0.7505,0.8197,-0.0011,0,0,106.1,67.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_94}]},1).to({state:[{t:this.instance_95}]},26).to({state:[{t:this.instance_94}]},33).to({state:[{t:this.instance_94}]},20).to({state:[]},1).wait(44));
	this.timeline.addTween(cjs.Tween.get(this.instance_94).wait(1).to({_off:false},0).to({_off:true,regX:106.1,regY:67.1,rotation:-0.0011,guide:{path:[782.9,761.1,849.4,697.9,870.7,355.9]},alpha:1},26,cjs.Ease.get(1)).wait(33).to({_off:false,rotation:-0.0011},0).to({x:836,y:197.15,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(44));

	// Símbolo_1
	this.instance_96 = new lib.Símbolo1();
	this.instance_96.setTransform(313.85,714.3,0.7505,0.8197,45,0,0,106.2,67);
	this.instance_96.alpha = 0;

	this.instance_97 = new lib.Símbolo1copiacopia();
	this.instance_97.setTransform(451.85,308.8,0.5738,0.6267,0,0,0,106.2,67);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_96}]}).to({state:[{t:this.instance_97}]},26).wait(99));
	this.timeline.addTween(cjs.Tween.get(this.instance_96).to({_off:true,scaleX:0.5738,scaleY:0.6267,rotation:0,x:451.85,y:308.8,alpha:1},26,cjs.Ease.quadInOut).wait(99));

	// Símbolo_1
	this.instance_98 = new lib.Símbolo1();
	this.instance_98.setTransform(1089.3,20.05,0.5838,0.6376,143.2977,0,0,106.2,67.1);
	this.instance_98.alpha = 0;
	this.instance_98._off = true;

	this.instance_99 = new lib.Símbolo1copia();
	this.instance_99.setTransform(924.4,447.35,0.5838,0.6376,-150.0014,0,0,106.2,67.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_98}]},3).to({state:[{t:this.instance_99}]},26).to({state:[{t:this.instance_98}]},33).to({state:[{t:this.instance_98}]},20).to({state:[]},1).wait(42));
	this.timeline.addTween(cjs.Tween.get(this.instance_98).wait(3).to({_off:false},0).to({_off:true,rotation:209.9986,guide:{path:[1089.3,20.2,1201.2,196.3,924.4,447.4]},alpha:1},26,cjs.Ease.quadInOut).wait(33).to({_off:false},0).to({x:919.35,y:556.15,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(42));

	// Símbolo_1
	this.instance_100 = new lib.DESCA11();
	this.instance_100.setTransform(113,2.8,0.5838,0.6376,120.0029,0,0,106.1,67);
	this.instance_100.alpha = 0;
	this.instance_100._off = true;

	this.instance_101 = new lib.DESCA1();
	this.instance_101.setTransform(412.7,447.15,0.5838,0.6376,165.002,0,0,106.2,67);

	this.instance_102 = new lib.Símbolo1();
	this.instance_102.setTransform(412.7,447.15,0.5838,0.6376,165.002,0,0,106.2,67);
	this.instance_102._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_100}]},2).to({state:[{t:this.instance_101}]},26).to({state:[{t:this.instance_102}]},33).to({state:[{t:this.instance_102}]},20).to({state:[]},1).wait(43));
	this.timeline.addTween(cjs.Tween.get(this.instance_100).wait(2).to({_off:false},0).to({_off:true,regX:106.2,rotation:165.002,guide:{path:[113,2.8,412.8,185,412.7,447]},alpha:1},26,cjs.Ease.cubicOut).wait(97));
	this.timeline.addTween(cjs.Tween.get(this.instance_102).wait(61).to({_off:false},0).to({x:432.25,y:594.45,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(43));

	// Símbolo_1
	this.instance_103 = new lib.Símbolo1();
	this.instance_103.setTransform(767.1,0.1,0.5838,0.6376,-111.528,0,0,106,67);
	this.instance_103._off = true;

	this.instance_104 = new lib.Símbolo1copia();
	this.instance_104.setTransform(553.65,352.05,0.5838,0.6376,180,0,0,106.1,67);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_103}]},1).to({state:[{t:this.instance_104}]},26).to({state:[{t:this.instance_103}]},33).to({state:[{t:this.instance_103}]},20).to({state:[]},1).wait(44));
	this.timeline.addTween(cjs.Tween.get(this.instance_103).wait(1).to({_off:false},0).to({_off:true,regX:106.1,rotation:-180,guide:{path:[767.1,0.1,497.7,75.2,553.7,352]}},26,cjs.Ease.cubicInOut).wait(33).to({_off:false},0).to({x:603.15,y:630.4,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(44));

	// Símbolo_1
	this.instance_105 = new lib.Símbolo1();
	this.instance_105.setTransform(622.05,749.85,0.5838,0.6376,-30.001,0,0,106.2,67.2);
	this.instance_105.alpha = 0;

	this.instance_106 = new lib.Símbolo1copia();
	this.instance_106.setTransform(590.25,384.75,0.5838,0.6376,-45.001,0,0,106.2,67.2);

	this.instance_107 = new lib.Símbolo1copia4();
	this.instance_107.setTransform(590.2,384.85,0.5838,0.6376,14.998,0,0,106.2,67.2);
	this.instance_107._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_105}]}).to({state:[{t:this.instance_106}]},26).to({state:[{t:this.instance_107}]},33).to({state:[{t:this.instance_107}]},20).to({state:[]},1).wait(45));
	this.timeline.addTween(cjs.Tween.get(this.instance_105).to({_off:true,rotation:-45.001,guide:{path:[622.1,749.8,459.1,620.3,590.2,384.8]},alpha:1},26,cjs.Ease.get(1)).wait(99));
	this.timeline.addTween(cjs.Tween.get(this.instance_107).wait(59).to({_off:false},0).to({x:667.85,y:198.45,alpha:0},20,cjs.Ease.cubicIn).to({_off:true},1).wait(45));

	// BOLITAS
	this.instance_108 = new lib.Símbolo11();
	this.instance_108.setTransform(608.55,376.05,0.9594,0.9594,0,0,0,451.1,154.8);
	this.instance_108._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_108).wait(63).to({_off:false},0).wait(62));

	// CTA
	this.instance_109 = new lib.Interpolación18("synched",0);
	this.instance_109.setTransform(652.3,511.6,0.1071,0.1071);
	this.instance_109._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_109).wait(97).to({_off:false},0).to({scaleX:1.0815,scaleY:1.0815},6,cjs.Ease.get(1)).to({scaleX:0.9457,scaleY:0.9457},7,cjs.Ease.quadInOut).to({scaleX:1,scaleY:1},5).wait(10));

	// TXT_top
	this.instance_110 = new lib.Interpolación1("synched",0);
	this.instance_110.setTransform(639.4,171.5);
	this.instance_110.alpha = 0;
	this.instance_110._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_110).wait(69).to({_off:false},0).to({alpha:1},8).wait(48));

	// Disney
	this.instance_111 = new lib.Símbolo7("synched",0);
	this.instance_111.setTransform(635.7,276.55,0.8087,0.8087,0,0,0,155,62.5);
	this.instance_111._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_111).wait(68).to({_off:false},0).wait(57));

	// Encanto
	this.instance_112 = new lib.Interpolación17("synched",0);
	this.instance_112.setTransform(708.1,403.5,1,0.8648);
	this.instance_112.alpha = 0;
	this.instance_112._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_112).wait(68).to({_off:false},0).to({scaleY:1,x:705.9,y:406.5,alpha:1},8,cjs.Ease.get(1)).wait(49));

	// AZUL
	this.instance_113 = new lib.Símbolo6();
	this.instance_113.setTransform(655.5,365,1,1,0,0,0,465.5,218);
	this.instance_113.alpha = 0;
	this.instance_113._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_113).wait(67).to({_off:false},0).to({alpha:1},12).wait(46));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(577.1,218.4,806.4,692.1);
// library properties:
lib.properties = {
	id: 'AB01BF9AA4334247B8D9C953F84FCF3C',
	width: 1280,
	height: 720,
	fps: 24,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"https://cdn.shopify.com/s/files/1/0871/6386/3349/files/DisneyTXT.png?v=1726675623", id:"DisneyTXT"},
		{src:"https://cdn.shopify.com/s/files/1/0871/6386/3349/files/LogoENCANTO_solo.png?v=1726675623", id:"LogoENCANTO_solo"},
		{src:"https://cdn.shopify.com/s/files/1/0871/6386/3349/files/Mapadebits17.png?v=1726675623", id:"Mapadebits17"},
		{src:"https://cdn.shopify.com/s/files/1/0871/6386/3349/files/Mapadebits18.png?v=1726675622", id:"Mapadebits18"},
		{src:"https://cdn.shopify.com/s/files/1/0871/6386/3349/files/Mapadebits19.png?v=1726675623", id:"Mapadebits19"},
		{src:"https://cdn.shopify.com/s/files/1/0871/6386/3349/files/parcheblanco.png?v=1726675623", id:"parcheblanco"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['AB01BF9AA4334247B8D9C953F84FCF3C'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;